// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/dateIcon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --pointColor: #463dc9;
}

.IsProc {
  position: relative;
  z-index: 1;
}
.IsProc .bars > span:nth-of-type(2) .bar {
  background-color: #eee;
}
.IsProc .bars.hover > span:nth-of-type(2) .bar:nth-child(1) {
  transform: rotate(45deg) translateY(5px);
}
.IsProc .bars.hover > span:nth-of-type(2) .bar:nth-child(2) {
  display: none;
}
.IsProc .bars.hover > span:nth-of-type(2) .bar:nth-child(3) {
  transform: rotate(-45deg) translateY(-5px);
}

.bars {
  position: relative;
  display: flex;
  align-items: center;
}
.bars:hover > span:nth-of-type(1) {
  transform: translateX(0%);
  opacity: 1;
}
.bars > span:nth-of-type(2) {
  display: flex;
  flex-direction: column;
  width: 30px;
  margin-left: 10px;
}
.bars > span:nth-of-type(2) .bar {
  width: 100%;
  margin: 3px 0;
  background-color: #222;
  height: 2px;
  border-radius: 1.5px;
  transition: 0.3s;
}
.bars > span:nth-of-type(1) {
  opacity: 0;
  transform: translateX(50%);
  transition: 0.3s;
  font-weight: normal;
}

.logoutButton {
  display: flex;
  width: 100px;
  height: 30px;
  border: none;
  border-radius: 15px;
  transition: 0.3s;
  margin-right: 10px;
  align-items: center;
}
.logoutButton > span {
  flex: 1 1;
  display: block;
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 80%;
  font-size: 0.8rem;
  text-align: center;
}
.logoutButton > span:nth-child(1) {
  margin-left: 7px;
}
.logoutButton > span:nth-child(2) {
  text-align: right;
}
.logoutButton > span > img {
  margin-top: 2px;
  display: inline-block;
  height: inherit;
}
.logoutButton:hover {
  background-color: var(--pointColor);
  color: #eee;
}

.footer {
  width: 100%;
  height: calc(100vh - 662px);
  background-color: #222;
  color: #eee;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Noto Sans KR", sans-serif;
  font-size: 16px;
}

ul,
ol,
li {
  list-style: none;
}

a {
  text-decoration: none;
}

fieldset {
  border: none;
}

table,
th,
td {
  border-collapse: collapse;
}

th,
td {
  padding: 15px;
}

.h {
  position: absolute;
  top: -999999px;
  opacity: 0;
}

body {
  color: #222;
  margin: 0;
  min-width: 1200px;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.checkbox {
  display: flex;
}
.checkbox .checkboxItem {
  padding: 5px;
}
.checkbox .checkboxItem > label {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  word-break: keep-all;
  cursor: pointer;
  position: relative;
}
.checkbox .checkboxItem > label.sale {
  margin-right: 20px;
}
.checkbox .checkboxItem > label.sale::after {
  content: "";
  width: 2px;
  height: 14px;
  display: block;
  position: absolute;
  right: -15px;
  top: 50%;
  transform: translateY(-44%);
  background-color: #ccc;
  cursor: default;
}
.checkbox .checkboxItem > label > input[type=checkbox] {
  cursor: pointer;
  display: block;
  margin-right: 5px;
  margin-bottom: -3px;
  accent-color: var(--pointColor);
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin: 50px auto;
  padding-bottom: 50px;
}
.pagination li {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  transition: all 0.3s;
}
.pagination li:hover, .pagination li:active, .pagination li.active {
  background-color: #eee;
  text-decoration: underline;
}
.pagination li:nth-child(1) a, .pagination li:nth-child(2) a, .pagination li:nth-last-child(1) a, .pagination li:nth-last-child(2) a {
  align-items: baseline;
  font-size: 20px;
}
.pagination li a {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: #333;
}

.pointText {
  font-weight: 500;
  color: var(--pointColor);
}

span.clickTd {
  transition: 0.5s;
  color: var(--pointColor);
  cursor: pointer;
}
span.clickTd:hover {
  text-decoration: underline;
}

button,
input[type=button] {
  font-size: 0.8rem;
  padding: 4px 10px;
  background-color: #fff;
  border: none;
  border-radius: 2px;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);
  cursor: pointer;
  transition: 0.3s;
}

button {
  word-break: keep-all;
}

input[type=text],
textarea {
  min-height: 30px;
  border: none;
  border-radius: 2px;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);
  padding: 5px;
}
input[type=text]:focus,
textarea:focus {
  outline: none;
}

input[type=checkbox] {
  cursor: pointer;
  accent-color: var(--pointColor);
}

.countBox {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
}
.countBox > ul {
  display: flex;
  justify-content: center;
  gap: 3vw;
}
.countBox > ul > li {
  display: flex;
  width: 16.6666666667;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  box-sizing: border-box;
  transition: 0.5s;
  margin-right: 10px;
}
.countBox > ul > li:hover .countIcon {
  background-color: #bbb;
}
.countBox > ul > li .countIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  transition: 0.3s;
}
.countBox > ul > li .countIcon > img {
  width: 30px;
  object-fit: cover;
}
.countBox > ul > li .countText {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.countBox > ul > li .countText span > strong {
  font-size: 1.2rem;
  color: #333;
}
.countBox > ul > li:nth-child(5) .countIcon > img {
  width: 25px;
}

.searchForm table {
  box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);
  width: 100%;
  border-collapse: collapse;
  border-radius: 5px;
  padding: 10px;
}
.searchForm th {
  font-weight: 500;
  text-align: left;
}
.searchForm thead {
  font-weight: bold;
  color: #fff;
  background: var(--pointColor);
}
.searchForm td,
.searchForm th {
  padding: 1em 1.5em;
  vertical-align: middle;
  word-break: keep-all;
}
.searchForm tr td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  transition: 0.3s;
}
.searchForm tr:last-child td {
  border: none;
}
.searchForm .searchBottonBox {
  display: flex;
  justify-content: center;
  padding: 30px 0;
}
.searchForm .searchBottonBox > button:nth-of-type(1) {
  display: inline-block;
  margin-right: 10px;
  display: flex;
}
.searchForm .searchBottonBox > button:nth-of-type(1) > span {
  display: block;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 0.8rem;
  text-align: center;
}
.searchForm .searchBottonBox > button:nth-of-type(1) > span:nth-child(1) {
  text-align: right;
}
.searchForm .searchBottonBox > button:nth-of-type(1) > span:nth-child(2) {
  margin-left: 3px;
}
.searchForm .searchBottonBox > button:nth-of-type(1) > span > img {
  margin-top: 2px;
  margin-left: -2px;
  display: inline-block;
  height: 18px;
}
.searchForm .searchBottonBox > button:nth-of-type(2) {
  color: #fff;
  background-color: var(--pointColor);
}

.resetIconButton {
  display: inline-block;
  margin-right: 10px;
  display: flex;
}
.resetIconButton > span {
  display: block;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 0.8rem;
  text-align: center;
}
.resetIconButton > span:nth-child(1) {
  text-align: right;
}
.resetIconButton > span:nth-child(2) {
  margin-left: 3px;
}
.resetIconButton > span > img {
  margin-top: 2px;
  margin-left: -2px;
  display: inline-block;
  height: 18px;
}

.datePickerBox {
  display: flex;
  align-items: center;
  gap: 16px;
}
.datePickerBox input[type=button] {
  margin: 0 2px;
}
.datePickerBox input[type=button].isActive {
  background-color: var(--pointColor);
  color: #eee;
}
.datePickerBox .datePicker {
  display: flex;
  flex-wrap: nowrap;
}
.datePickerBox .datePicker .react-datepicker-popper[data-placement^=bottom] {
  padding-top: 5px;
}
.datePickerBox .datePicker .react-datepicker-popper .react-datepicker {
  border: none;
  border-radius: 2px;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);
  padding: 10px;
}
.datePickerBox .datePicker .react-datepicker-popper .react-datepicker .react-datepicker__triangle::before, .datePickerBox .datePicker .react-datepicker-popper .react-datepicker .react-datepicker__triangle::after {
  border: none;
}
.datePickerBox .datePicker .react-datepicker-popper .react-datepicker .react-datepicker__navigation {
  box-shadow: none;
  top: 7px;
}
.datePickerBox .datePicker .react-datepicker-popper .react-datepicker .react-datepicker__navigation .react-datepicker__navigation-icon::before {
  border-width: 1px 1px 0 0;
  border-color: #999;
  top: 14px;
}
.datePickerBox .datePicker .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__header {
  background-color: #fff;
  border-bottom: none;
  padding: 5px 0;
}
.datePickerBox .datePicker .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__current-month {
  font-weight: normal;
  padding-bottom: 14px;
}
.datePickerBox .datePicker .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__day-names .react-datepicker__day-name {
  font-size: 14px;
}
.datePickerBox .datePicker .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day {
  border-radius: 50%;
  transition: 0.3s;
}
.datePickerBox .datePicker .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day:hover {
  background-color: rgba(70, 61, 201, 0.2392156863);
}
.datePickerBox .datePicker .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day--today {
  color: var(--pointColor);
  text-decoration: underline;
}
.datePickerBox .datePicker .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day--selected {
  background-color: var(--pointColor);
}
.datePickerBox .datePicker .react-datepicker-popper .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day--keyboard-selected {
  background-color: rgba(161, 161, 161, 0.2392156863);
}
.datePickerBox div > .react-datepicker__input-container {
  position: relative;
}
.datePickerBox div > .react-datepicker__input-container .input-datepicker {
  height: 30px;
  border: none;
  margin: 0px 2px;
  border-radius: 2px;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);
  text-indent: 30px;
  font-size: 0.9rem;
}
.datePickerBox div > .react-datepicker__input-container::before {
  content: "";
  display: block;
  position: absolute;
  left: 10px;
  top: 50%;
  width: 16px;
  height: 16px;
  transform: translateY(-46%);
  background: center/contain no-repeat url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.container {
  position: relative;
}
.container .dropdown-button {
  display: flex;
  width: 100%;
  padding: 0 40px 0 20px;
  height: 34px;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.container .dropdown-button > span {
  font-size: 0.8rem;
}
.container .dropdown-button .dropdown-button-arrow {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.container .dropdown-container {
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.container .dropdown-container.open .dropdown-content {
  display: block;
}
.container .dropdown-container .dropdown-content {
  position: absolute; /* 드롭다운을 absolute로 설정 */
  min-width: 100%;
  top: 100%; /* 드롭다운을 부모 아래에 표시 */
  left: 0;
  z-index: 5; /* 다른 요소 위에 나타나도록 설정 */
  display: none; /* 초기에는 숨겨두기 */
  flex-direction: row;
  display: flex;
  word-break: keep-all;
}
.container .dropdown-container .dropdown-content > li {
  text-align: center;
  width: 100%;
  background-color: #fff;
  padding: 5px;
  box-sizing: border-box;
  transition: 0.1s;
}
.container .dropdown-container .dropdown-content > li:hover {
  color: #f1f1f1;
  background-color: var(--pointColor);
}
.container .dropdown-container .dropdown-content > li > span {
  display: block;
  width: 100%;
}

.modal,
.overlay {
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 10;
}
.modal .modal-content,
.overlay .modal-content {
  position: relative;
  z-index: 11;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  border-radius: 10px;
  max-width: 60%;
  min-width: 50%;
  min-height: 80%;
  max-height: 80%;
  text-align: left;
  overflow: hidden;
  background-color: #f9f9f9;
}
.modal .modal-content .modal-header,
.overlay .modal-content .modal-header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding: 40px 30px 20px 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #b6b6b6;
  background: #f1f1f1;
}
.modal .modal-content .modal-header > h2,
.overlay .modal-content .modal-header > h2 {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 10px;
}
.modal .modal-content .modal-header > p,
.overlay .modal-content .modal-header > p {
  font-size: 12px;
  color: #949494;
}
.modal .modal-content .modal-body,
.overlay .modal-content .modal-body {
  position: fixed;
  top: 111px;
  left: 0;
  width: 100%;
  height: calc(100% - 111px);
  padding: 30px;
  overflow-y: scroll;
  /* 아래의 모든 코드는 영역::코드로 사용 */
}
.modal .modal-content .modal-body::-webkit-scrollbar,
.overlay .modal-content .modal-body::-webkit-scrollbar {
  width: 10px; /* 스크롤바의 너비 */
  background-color: #f1f1f1;
}
.modal .modal-content .modal-body::-webkit-scrollbar-thumb,
.overlay .modal-content .modal-body::-webkit-scrollbar-thumb {
  width: 5px;
  height: 30%; /* 스크롤바의 길이 */
  background: #b6b6b6; /* 스크롤바의 색상 */
  border-radius: 10px;
}
.modal .modal-content .modal-body::-webkit-scrollbar-track,
.overlay .modal-content .modal-body::-webkit-scrollbar-track {
  background: #eee; /*스크롤바 뒷 배경 색상*/
  border-radius: 0 10px 10px 0;
  box-sizing: border-box;
}
.modal .modal-content .modal-body .modal-row,
.overlay .modal-content .modal-body .modal-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
}
.modal .modal-content .modal-body .modal-row .modal-column,
.overlay .modal-content .modal-body .modal-row .modal-column {
  margin-right: 10px;
}
.modal .modal-content .modal-body .modal-row .modal-column:last-child,
.overlay .modal-content .modal-body .modal-row .modal-column:last-child {
  margin-right: 0px;
}
.modal .modal-content .modal-body .modal-row.alignCenter,
.overlay .modal-content .modal-body .modal-row.alignCenter {
  align-items: center;
}
.modal .modal-content .modal-body .modal-row.alignCenter .rowValue,
.overlay .modal-content .modal-body .modal-row.alignCenter .rowValue {
  flex: 3 1;
  display: flex;
  flex-direction: column;
}
.modal .modal-content .modal-body .modal-row.alignCenter .rowValue > span.value,
.overlay .modal-content .modal-body .modal-row.alignCenter .rowValue > span.value {
  width: 100%;
  min-width: 160px;
  min-height: 34px;
  border: 1px solid #ddd;
  padding: 5px 10px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.modal .modal-content .modal-body .modal-row.alignCenter .rowValue > span.value > input,
.overlay .modal-content .modal-body .modal-row.alignCenter .rowValue > span.value > input {
  display: inline-block;
  width: 100%;
}
.modal .modal-content .modal-body .modal-row.alignCenter > .addressButton,
.overlay .modal-content .modal-body .modal-row.alignCenter > .addressButton {
  height: 27px;
}
.modal .modal-content .modal-body .row-title,
.overlay .modal-content .modal-body .row-title {
  font-weight: 600;
  font-size: 14px;
  color: #949494;
  text-indent: 10px;
  margin-bottom: 10px;
}
.modal .modal-content .modal-body .modal-column,
.overlay .modal-content .modal-body .modal-column {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 10px;
}
.modal .modal-content .modal-body .modal-column .modal-column-row,
.overlay .modal-content .modal-body .modal-column .modal-column-row {
  display: flex;
  flex-direction: row;
  word-break: keep-all;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
}
.modal .modal-content .modal-body .modal-column .modal-column-row > .key,
.overlay .modal-content .modal-body .modal-column .modal-column-row > .key {
  margin-bottom: 0px;
  margin-right: 10px;
}
.modal .modal-content .modal-body .modal-column span.key,
.overlay .modal-content .modal-body .modal-column span.key {
  font-weight: 600;
  font-size: 14px;
  color: #949494;
  text-indent: 10px;
  margin-bottom: 10px;
  position: relative;
}
.modal .modal-content .modal-body .modal-column span.key::before,
.overlay .modal-content .modal-body .modal-column span.key::before {
  content: "";
  display: block;
  width: 2px;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  background-color: #ddd;
}
.modal .modal-content .modal-body .modal-column span.key.noindent::before,
.overlay .modal-content .modal-body .modal-column span.key.noindent::before {
  display: none;
}
.modal .modal-content .modal-body .modal-column span.value,
.overlay .modal-content .modal-body .modal-column span.value {
  display: flex;
  width: 100%;
  min-width: 160px;
  min-height: 34px;
  border: 1px solid #ddd;
  padding: 5px 10px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.modal .modal-content .modal-body .modal-column span.value > input,
.overlay .modal-content .modal-body .modal-column span.value > input {
  display: inline-block;
  width: 100%;
}
.modal .modal-content .modal-body .modal-column span.value.values,
.overlay .modal-content .modal-body .modal-column span.value.values {
  padding: 0px;
}
.modal .modal-content .modal-body .modal-column span.value.values > span,
.overlay .modal-content .modal-body .modal-column span.value.values > span {
  flex: 2 1;
  min-width: 80px;
  padding: 5px 10px;
}
.modal .modal-content .modal-body .modal-column span.value.values > span:first-child,
.overlay .modal-content .modal-body .modal-column span.value.values > span:first-child {
  flex: 1 1;
  border-right: 1px solid #ddd;
}
.modal .modal-content .modal-body .modal-column span.value.resetButton,
.overlay .modal-content .modal-body .modal-column span.value.resetButton {
  justify-content: space-between;
}
.modal .modal-content .modal-body .modal-column span.value.resetButton .resetIconButton,
.overlay .modal-content .modal-body .modal-column span.value.resetButton .resetIconButton {
  margin-right: 0px;
}
.modal .close-modal,
.overlay .close-modal {
  position: fixed;
  top: 40px;
  right: 30px;
  width: 24px;
  height: 24px;
  border: 1px solid #b6b6b6;
  border-radius: 12px;
  display: block;
  padding: 5px;
  cursor: pointer;
  transition: 0.2s;
}
.modal .close-modal:hover,
.overlay .close-modal:hover {
  background: #b6b6b6;
}
.modal .close-modal:hover::before, .modal .close-modal:hover::after,
.overlay .close-modal:hover::before,
.overlay .close-modal:hover::after {
  background-color: #eee;
}
.modal .close-modal::before, .modal .close-modal::after,
.overlay .close-modal::before,
.overlay .close-modal::after {
  content: "";
  position: absolute;
  width: 80%;
  height: 1px; /* 가로선 두께 설정 */
  background: #b6b6b6; /* 가로선 색상 설정 */
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  transition: 0.2s;
}
.modal .close-modal::before,
.overlay .close-modal::before {
  transform: rotate(45deg);
}
.modal .close-modal::after,
.overlay .close-modal::after {
  transform: rotate(-45deg);
}
.modal button,
.overlay button {
  margin-left: 5px;
  word-break: keep-all;
}
.modal button.address,
.overlay button.address {
  width: 200px;
}

.overlay {
  background: rgba(49, 49, 49, 0.8);
}

.checkboxItem {
  padding: 5px;
}
.checkboxItem > label {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  word-break: keep-all;
  cursor: pointer;
  position: relative;
}
.checkboxItem > label.sale {
  margin-right: 20px;
}
.checkboxItem > label.sale::after {
  content: "";
  width: 2px;
  height: 14px;
  display: block;
  position: absolute;
  right: -15px;
  top: 50%;
  transform: translateY(-44%);
  background-color: #ccc;
  cursor: default;
}
.checkboxItem > label > input[type=checkbox] {
  cursor: pointer;
  display: block;
  margin-right: 5px;
  margin-bottom: -3px;
  accent-color: var(--pointColor);
  border-radius: 0;
}

.radioItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  word-break: keep-all;
  cursor: pointer;
  position: relative;
}
.radioItem > label {
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 5px;
}
.radioItem > label input[type=radio] {
  margin-right: 5px;
  margin-bottom: -3px;
  background-color: #eee;
}
.radioItem > label input[type=radio]:checked {
  accent-color: var(--pointColor);
}

.order-table {
  position: relative;
  width: 100%;
  z-index: 10;
}
.order-table .table-top {
  display: flex;
  justify-content: space-between;
  padding: 20px 10px 10px 10px;
}
.order-table .table-top .table-top-left {
  display: flex;
}
.order-table .table-top .table-top-left > p,
.order-table .table-top .table-top-left button:nth-of-type(1) {
  margin-right: 10px;
}
.order-table .table-top .table-top-right {
  display: flex;
}
.order-table table {
  table-layout: fixed;
  width: 100%;
  box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  border-radius: 5px;
}
.order-table table thead {
  background: #efefef;
}
.order-table table thead th {
  font-weight: 500;
  word-break: keep-all;
  white-space: nowrap;
}
.order-table table tr {
  transition: 0.5s;
}
.order-table table tr:hover {
  background-color: #eee;
}
.order-table table td,
.order-table table th {
  word-wrap: break-word;
  padding: 1em 0.5em;
  vertical-align: middle;
  box-sizing: border-box;
  text-align: center;
}
.order-table table th:nth-child(6) {
  width: 200px;
  min-width: 200px;
}
.order-table table th:nth-child(7) {
  width: 300px;
  min-width: 300px;
}
.order-table table tbody {
  position: relative;
  overflow: hidden;
}
.order-table table tbody .defaultTable {
  background: none;
}
.order-table table tbody .defaultTable td > div {
  padding: 50px 0;
}
.order-table table tbody .loading {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(49, 49, 49, 0.5);
}
.order-table table tbody .loading .loadingImg {
  display: block;
  animation: rotate 5s infinite;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.order-table table td {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.order-table table td .tdInput {
  display: flex;
}
.order-table table td .tdInput > input {
  width: 100%;
}
.order-table table td .deliveryCompanyTrackingNumber {
  display: flex;
  align-items: center;
}

.addressCloseButton {
  position: fixed;
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
  z-index: 4;
}

.addressOverlay {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #eee;
  z-index: 2;
}

.searchWord {
  display: flex;
}
.searchWord > div {
  display: flex;
  flex-direction: column;
  margin-right: 20px;
}
.searchWord > div > label span {
  display: inline-block;
  margin-right: 10px;
}
.searchWord > div > label:nth-child(1) {
  display: flex;
  justify-content: flex-start;
}
.searchWord > div:nth-child(1) label {
  height: 75px;
}
.searchWord > div:nth-child(2) label:nth-of-type(1), .searchWord > div:nth-child(3) label:nth-of-type(1) {
  margin-bottom: 5px;
}

.categoriesContainer {
  display: flex;
}
.categoriesContainer > div {
  margin-right: 5px;
}

.hub-table {
  position: relative;
  width: 100%;
}
.hub-table::-webkit-scrollbar {
  height: 10px; /* 스크롤바의 너비 */
  background-color: #f1f1f1;
}
.hub-table::-webkit-scrollbar-thumb {
  width: 5px;
  height: 30%; /* 스크롤바의 길이 */
  background: #b6b6b6; /* 스크롤바의 색상 */
  border-radius: 10px;
}
.hub-table::-webkit-scrollbar-track {
  background: #eee; /*스크롤바 뒷 배경 색상*/
  border-radius: 0 10px 10px 0;
  box-sizing: border-box;
}
.hub-table .table-top {
  display: flex;
  justify-content: space-between;
  padding: 20px 10px 10px 10px;
}
.hub-table .table-top .table-top-left {
  display: flex;
}
.hub-table .table-top .table-top-right {
  display: flex;
}
.hub-table .data-table {
  position: relative;
  width: 100%;
  height: auto;
  min-height: 110px;
  display: flex;
  box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  border-radius: 5px;
}
.hub-table .data-table .fixed-table {
  position: relative;
  width: 40%;
  height: auto;
  overflow-x: auto;
  overflow-y: hidden;
  z-index: 1;
}
.hub-table .data-table .fixed-table > table {
  width: 100%;
  box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  border-radius: 5px 0 0 5px;
}
.hub-table .data-table .fixed-table > table thead {
  background: #efefef;
}
.hub-table .data-table .fixed-table > table thead th {
  font-weight: 500;
}
.hub-table .data-table .fixed-table > table td {
  border-right: none;
}
.hub-table .data-table .scroll-table {
  position: relative;
  width: 60%;
  height: auto;
  overflow-x: auto;
  overflow-y: hidden;
}
.hub-table .data-table .scroll-table::-webkit-scrollbar {
  width: 10px; /* 스크롤바의 너비 */
  height: 10px;
  background-color: #f1f1f1;
}
.hub-table .data-table .scroll-table::-webkit-scrollbar-thumb {
  width: 5px;
  height: 30%; /* 스크롤바의 길이 */
  background: #b6b6b6; /* 스크롤바의 색상 */
  border-radius: 10px;
}
.hub-table .data-table .scroll-table::-webkit-scrollbar-track {
  background: #eee; /*스크롤바 뒷 배경 색상*/
  border-radius: 0 10px 10px 0;
  box-sizing: border-box;
}
.hub-table .data-table table {
  border-collapse: collapse;
  position: absolute;
  background: #fff;
  min-height: 200px;
  overflow: hidden;
  box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  border-radius: 0 5px 5px 0;
}
.hub-table .data-table table thead {
  background: #efefef;
}
.hub-table .data-table table thead tr th {
  width: 200px;
  height: 50px;
  font-weight: 500;
  word-break: keep-all;
  white-space: nowrap;
}
.hub-table .data-table table tbody {
  position: relative;
}
.hub-table .data-table table tbody tr {
  transition: 0.5s;
}
.hub-table .data-table table tbody tr td {
  width: 200px;
  height: 50px;
  word-break: keep-all;
  white-space: nowrap;
  vertical-align: middle;
  text-align: center;
  padding: 10px 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.hub-table .data-table table tbody .defaultTable {
  background: none;
}
.hub-table .data-table table tbody .defaultTable td {
  text-align: left;
  padding-left: 10%;
}
.hub-table .data-table table tbody .defaultTable td > div {
  padding: 50px 0;
}

.slide-modal,
.slide-overlay {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  overflow: visible;
}
.slide-modal .slide-overlay,
.slide-overlay .slide-overlay {
  background: rgba(49, 49, 49, 0.8);
}
.slide-modal .slide-modal-content,
.slide-overlay .slide-modal-content {
  position: relative;
  overflow-x: auto;
  top: 0;
  left: 10%;
  border-radius: 10px 0 0 10px;
  width: 90%;
  height: 100vh;
  text-align: left;
  z-index: 100;
}
.slide-modal .slide-modal-content .modal-header,
.slide-overlay .slide-modal-content .modal-header {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  padding: 40px 30px 20px 30px;
  border-bottom: 1px solid #b6b6b6;
  background: #f1f1f1;
  z-index: 2;
}
.slide-modal .slide-modal-content .modal-header > h2,
.slide-overlay .slide-modal-content .modal-header > h2 {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 10px;
}
.slide-modal .slide-modal-content .modal-header > p,
.slide-overlay .slide-modal-content .modal-header > p {
  font-size: 12px;
  color: #949494;
}
.slide-modal .slide-modal-content .close-modal,
.slide-overlay .slide-modal-content .close-modal {
  position: absolute;
  top: 40px;
  right: 30px;
  width: 24px;
  height: 24px;
  border: 1px solid #b6b6b6;
  border-radius: 12px;
  display: block;
  padding: 5px;
  cursor: pointer;
  transition: 0.2s;
  z-index: 3;
}
.slide-modal .slide-modal-content .close-modal:hover,
.slide-overlay .slide-modal-content .close-modal:hover {
  background: #b6b6b6;
}
.slide-modal .slide-modal-content .close-modal:hover::before, .slide-modal .slide-modal-content .close-modal:hover::after,
.slide-overlay .slide-modal-content .close-modal:hover::before,
.slide-overlay .slide-modal-content .close-modal:hover::after {
  background-color: #eee;
}
.slide-modal .slide-modal-content .close-modal::before, .slide-modal .slide-modal-content .close-modal::after,
.slide-overlay .slide-modal-content .close-modal::before,
.slide-overlay .slide-modal-content .close-modal::after {
  content: "";
  position: absolute;
  width: 80%;
  height: 1px; /* 가로선 두께 설정 */
  background: #b6b6b6; /* 가로선 색상 설정 */
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  transition: 0.2s;
}
.slide-modal .slide-modal-content .close-modal::before,
.slide-overlay .slide-modal-content .close-modal::before {
  transform: rotate(45deg);
}
.slide-modal .slide-modal-content .close-modal::after,
.slide-overlay .slide-modal-content .close-modal::after {
  transform: rotate(-45deg);
}
.slide-modal .slide-modal-content button,
.slide-overlay .slide-modal-content button {
  word-break: keep-all;
}
.slide-modal .slide-modal-content .modal-body,
.slide-overlay .slide-modal-content .modal-body {
  position: relative;
  width: 100%;
  top: 112px;
  height: calc(100vh - 112px);
  padding: 30px;
  overflow: auto;
  z-index: 1;
  background-color: #f9f9f9;
}
.slide-modal .slide-modal-content .modal-body::-webkit-scrollbar,
.slide-overlay .slide-modal-content .modal-body::-webkit-scrollbar {
  width: 10px; /* 스크롤바의 너비 */
  height: 10px;
  background-color: #f1f1f1;
}
.slide-modal .slide-modal-content .modal-body::-webkit-scrollbar-thumb,
.slide-overlay .slide-modal-content .modal-body::-webkit-scrollbar-thumb {
  width: 5px;
  height: 30%; /* 스크롤바의 길이 */
  background: #b6b6b6; /* 스크롤바의 색상 */
  border-radius: 10px;
}
.slide-modal .slide-modal-content .modal-body::-webkit-scrollbar-track,
.slide-overlay .slide-modal-content .modal-body::-webkit-scrollbar-track {
  background: #eee; /*스크롤바 뒷 배경 색상*/
  border-radius: 0 10px 10px 0;
  box-sizing: border-box;
}
.slide-modal .slide-modal-content .modal-body .detailModalInfo,
.slide-overlay .slide-modal-content .modal-body .detailModalInfo {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  background-color: #f9f9f9;
  margin-bottom: 40px;
}
.slide-modal .slide-modal-content .modal-body .detailModalInfo .imgInfo,
.slide-overlay .slide-modal-content .modal-body .detailModalInfo .imgInfo {
  width: 38%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 5px;
  box-sizing: border-box;
  position: relative;
}
.slide-modal .slide-modal-content .modal-body .detailModalInfo .imgInfo .imgList,
.slide-overlay .slide-modal-content .modal-body .detailModalInfo .imgInfo .imgList {
  width: 20%;
  min-width: 76px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.slide-modal .slide-modal-content .modal-body .detailModalInfo .imgInfo .imgList li,
.slide-overlay .slide-modal-content .modal-body .detailModalInfo .imgInfo .imgList li {
  width: 76px;
  height: 76px;
  padding: 5px;
  border: 1px solid #b6b6b6;
  border-radius: 10px;
}
.slide-modal .slide-modal-content .modal-body .detailModalInfo .imgInfo .imgList li > img,
.slide-overlay .slide-modal-content .modal-body .detailModalInfo .imgInfo .imgList li > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}
.slide-modal .slide-modal-content .modal-body .detailModalInfo .imgInfo > .img,
.slide-overlay .slide-modal-content .modal-body .detailModalInfo .imgInfo > .img {
  width: 80%;
  max-height: 600px;
  margin-bottom: 10px;
  padding: 6px;
  border: 1px solid #b6b6b6;
}
.slide-modal .slide-modal-content .modal-body .detailModalInfo .imgInfo > .img > img,
.slide-overlay .slide-modal-content .modal-body .detailModalInfo .imgInfo > .img > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.slide-modal .slide-modal-content .modal-body .detailModalInfo > .info,
.slide-overlay .slide-modal-content .modal-body .detailModalInfo > .info {
  width: 60%;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}
.slide-modal .slide-modal-content .modal-body .detail-content,
.slide-overlay .slide-modal-content .modal-body .detail-content {
  margin-bottom: 40px;
  position: relative;
  width: 100%;
}
.slide-modal .slide-modal-content .modal-body .detail-content .detail-content-top,
.slide-overlay .slide-modal-content .modal-body .detail-content .detail-content-top {
  display: flex;
  justify-content: space-between;
}
.slide-modal .slide-modal-content .modal-body .detail-content .detail-content-top .detail-content-title,
.slide-overlay .slide-modal-content .modal-body .detail-content .detail-content-top .detail-content-title {
  position: relative;
  display: inline-block;
  font-size: 18px;
  text-indent: 10px;
  margin-bottom: 20px;
}
.slide-modal .slide-modal-content .modal-body .detail-content .detail-content-top .detail-content-title::before,
.slide-overlay .slide-modal-content .modal-body .detail-content .detail-content-top .detail-content-title::before {
  content: "";
  display: block;
  width: 2px;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  background-color: #ddd;
}
.slide-modal .slide-modal-content .modal-body .detail-content .detail-content-top .buttonBox,
.slide-overlay .slide-modal-content .modal-body .detail-content .detail-content-top .buttonBox {
  display: flex;
  height: 34px;
}
.slide-modal .slide-modal-content .modal-body .detail-content .detail-content-top .buttonBox > .reset,
.slide-overlay .slide-modal-content .modal-body .detail-content .detail-content-top .buttonBox > .reset {
  display: inline-block;
  display: flex;
  align-items: center;
  justify-content: center;
}
.slide-modal .slide-modal-content .modal-body .detail-content .detail-content-top .buttonBox > .reset > span,
.slide-overlay .slide-modal-content .modal-body .detail-content .detail-content-top .buttonBox > .reset > span {
  display: block;
  font-size: 0.8rem;
  text-align: center;
}
.slide-modal .slide-modal-content .modal-body .detail-content .detail-content-top .buttonBox > .reset > span > img,
.slide-overlay .slide-modal-content .modal-body .detail-content .detail-content-top .buttonBox > .reset > span > img {
  margin-top: 4px;
  height: 18px;
}
.slide-modal .slide-modal-content .modal-body .detail-content .detail-content-top .buttonBox > button,
.slide-overlay .slide-modal-content .modal-body .detail-content .detail-content-top .buttonBox > button {
  margin-right: 5px;
}
.slide-modal .slide-modal-content .modal-body .detail-content .detail-content-top .buttonBox > button:last-child,
.slide-overlay .slide-modal-content .modal-body .detail-content .detail-content-top .buttonBox > button:last-child {
  margin-right: 0px;
}
.slide-modal .slide-modal-content .modal-body .detail-content .detail-content-html,
.slide-overlay .slide-modal-content .modal-body .detail-content .detail-content-html {
  width: 100%;
}
.slide-modal .slide-modal-content .modal-body .detail-content .detail-content-html > textarea,
.slide-overlay .slide-modal-content .modal-body .detail-content .detail-content-html > textarea {
  border: none;
  display: block;
  width: 100%;
  min-height: 400px;
  background-color: white;
  box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  border-radius: 5px;
  white-space: normal;
  padding: 10px;
  resize: none;
}
.slide-modal .slide-modal-content .modal-body .detail-content > img,
.slide-overlay .slide-modal-content .modal-body .detail-content > img {
  display: block;
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 10;
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content {
  position: absolute;
  left: 50%;
  top: 140px;
  z-index: 101;
  transform: translateX(-42%);
  border-radius: 10px;
  max-width: 80%;
  min-width: 60%;
  min-height: 80%;
  max-height: 80%;
  background-color: #f9f9f9;
  overflow: hidden;
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content .modal-header,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content .modal-header,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content .modal-header,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content .modal-header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding: 30px 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #b6b6b6;
  background: #f1f1f1;
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content .modal-header .imagePreview-header-text,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content .modal-header .imagePreview-header-text,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content .modal-header .imagePreview-header-text,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content .modal-header .imagePreview-header-text {
  font-weight: 600;
  font-size: 14px;
  color: #949494;
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content .modal-body,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content .modal-body,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content .modal-body,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content .modal-body {
  position: fixed;
  top: 95px;
  left: 0;
  width: 100%;
  height: calc(100% - 95px);
  padding: 30px;
  overflow-y: scroll;
  /* 아래의 모든 코드는 영역::코드로 사용 */
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content .modal-body::-webkit-scrollbar,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content .modal-body::-webkit-scrollbar,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content .modal-body::-webkit-scrollbar,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content .modal-body::-webkit-scrollbar {
  width: 10px; /* 스크롤바의 너비 */
  background-color: #f1f1f1;
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content .modal-body::-webkit-scrollbar-thumb,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content .modal-body::-webkit-scrollbar-thumb,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content .modal-body::-webkit-scrollbar-thumb,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content .modal-body::-webkit-scrollbar-thumb {
  width: 5px;
  height: 30%; /* 스크롤바의 길이 */
  background: #b6b6b6; /* 스크롤바의 색상 */
  border-radius: 10px;
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content .modal-body::-webkit-scrollbar-track,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content .modal-body::-webkit-scrollbar-track,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .imagePreviewPopup-content .modal-body::-webkit-scrollbar-track,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .imagePreviewPopup-content .modal-body::-webkit-scrollbar-track {
  background: #eee; /*스크롤바 뒷 배경 색상*/
  border-radius: 0 10px 10px 0;
  box-sizing: border-box;
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .close-modal,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .close-modal,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .close-modal,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .close-modal {
  position: fixed;
  top: 30px;
  right: 30px;
  width: 24px;
  height: 24px;
  border: 1px solid #b6b6b6;
  border-radius: 12px;
  display: block;
  padding: 5px;
  cursor: pointer;
  transition: 0.2s;
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .close-modal:hover,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .close-modal:hover,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .close-modal:hover,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .close-modal:hover {
  background: #b6b6b6;
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .close-modal:hover::before, .slide-modal .slide-modal-content .modal-body .detail-content .modal .close-modal:hover::after,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .close-modal:hover::before,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .close-modal:hover::after,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .close-modal:hover::before,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .close-modal:hover::after,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .close-modal:hover::before,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .close-modal:hover::after {
  background-color: #eee;
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .close-modal::before, .slide-modal .slide-modal-content .modal-body .detail-content .modal .close-modal::after,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .close-modal::before,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .close-modal::after,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .close-modal::before,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .close-modal::after,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .close-modal::before,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .close-modal::after {
  content: "";
  position: absolute;
  width: 80%;
  height: 1px; /* 가로선 두께 설정 */
  background: #b6b6b6; /* 가로선 색상 설정 */
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  transition: 0.2s;
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .close-modal::before,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .close-modal::before,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .close-modal::before,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .close-modal::before {
  transform: rotate(45deg);
}
.slide-modal .slide-modal-content .modal-body .detail-content .modal .close-modal::after,
.slide-modal .slide-modal-content .modal-body .detail-content .overlay .close-modal::after,
.slide-overlay .slide-modal-content .modal-body .detail-content .modal .close-modal::after,
.slide-overlay .slide-modal-content .modal-body .detail-content .overlay .close-modal::after {
  transform: rotate(-45deg);
}
.slide-modal .slide-modal-content .modal-body .modal-row,
.slide-overlay .slide-modal-content .modal-body .modal-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
}
.slide-modal .slide-modal-content .modal-body .modal-row .modal-column,
.slide-overlay .slide-modal-content .modal-body .modal-row .modal-column {
  margin-right: 10px;
}
.slide-modal .slide-modal-content .modal-body .modal-row .modal-column:last-child,
.slide-overlay .slide-modal-content .modal-body .modal-row .modal-column:last-child {
  margin-right: 0px;
}
.slide-modal .slide-modal-content .modal-body .row-title,
.slide-overlay .slide-modal-content .modal-body .row-title {
  font-weight: 600;
  font-size: 14px;
  color: #949494;
  text-indent: 10px;
  margin-bottom: 10px;
}
.slide-modal .slide-modal-content .modal-body .modal-column,
.slide-overlay .slide-modal-content .modal-body .modal-column {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 10px;
}
.slide-modal .slide-modal-content .modal-body .modal-column .modal-column-row,
.slide-overlay .slide-modal-content .modal-body .modal-column .modal-column-row {
  display: flex;
  flex-direction: row;
  word-break: keep-all;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
}
.slide-modal .slide-modal-content .modal-body .modal-column .modal-column-row > .key,
.slide-overlay .slide-modal-content .modal-body .modal-column .modal-column-row > .key {
  margin-bottom: 0px;
  margin-right: 10px;
}
.slide-modal .slide-modal-content .modal-body .modal-column span.key,
.slide-overlay .slide-modal-content .modal-body .modal-column span.key {
  font-weight: 600;
  font-size: 14px;
  color: #949494;
  text-indent: 10px;
  margin-bottom: 10px;
  position: relative;
}
.slide-modal .slide-modal-content .modal-body .modal-column span.key::before,
.slide-overlay .slide-modal-content .modal-body .modal-column span.key::before {
  content: "";
  display: block;
  width: 2px;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  background-color: #ddd;
}
.slide-modal .slide-modal-content .modal-body .modal-column span.key.noindent::before,
.slide-overlay .slide-modal-content .modal-body .modal-column span.key.noindent::before {
  display: none;
}
.slide-modal .slide-modal-content .modal-body .modal-column span.value,
.slide-overlay .slide-modal-content .modal-body .modal-column span.value {
  display: flex;
  width: 100%;
  min-width: 160px;
  min-height: 34px;
  border: 1px solid #ddd;
  padding: 5px 10px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.slide-modal .slide-modal-content .modal-body .modal-column span.value > input,
.slide-overlay .slide-modal-content .modal-body .modal-column span.value > input {
  display: inline-block;
  width: 100%;
}
.slide-modal .slide-modal-content .modal-body .modal-column span.value.values,
.slide-overlay .slide-modal-content .modal-body .modal-column span.value.values {
  padding: 0px;
}
.slide-modal .slide-modal-content .modal-body .modal-column span.value.values > span,
.slide-overlay .slide-modal-content .modal-body .modal-column span.value.values > span {
  flex: 2 1;
  min-width: 80px;
  padding: 5px 10px;
}
.slide-modal .slide-modal-content .modal-body .modal-column span.value.values > span:first-child,
.slide-overlay .slide-modal-content .modal-body .modal-column span.value.values > span:first-child {
  flex: 1 1;
  border-right: 1px solid #ddd;
}
.slide-modal .slide-modal-content .modal-body .modal-column span.value > .reset,
.slide-overlay .slide-modal-content .modal-body .modal-column span.value > .reset {
  display: inline-block;
  display: flex;
  align-items: center;
  justify-content: center;
}
.slide-modal .slide-modal-content .modal-body .modal-column span.value > .reset > span,
.slide-overlay .slide-modal-content .modal-body .modal-column span.value > .reset > span {
  display: block;
  font-size: 0.8rem;
  text-align: center;
}
.slide-modal .slide-modal-content .modal-body .modal-column span.value > .reset > span > img,
.slide-overlay .slide-modal-content .modal-body .modal-column span.value > .reset > span > img {
  margin-top: 4px;
  height: 18px;
}
.slide-modal .slide-modal-content .modal-body .modal-column .modResetButton,
.slide-overlay .slide-modal-content .modal-body .modal-column .modResetButton {
  position: absolute;
  right: 20px;
  top: 0;
}

.loading {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(49, 49, 49, 0.5);
  transition: 0.3s;
}
.loading > td {
  border: none !important;
}
.loading.hub .loadingImg {
  margin-left: -100%;
}
.loading.noBg {
  transition: 0.3s;
  background-color: rgba(49, 49, 49, 0);
}
.loading .loadingImg {
  display: block;
  animation: rotate 5s infinite;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.market-layout {
  padding: 40px;
  display: flex;
  gap: 6%;
}

.market-top {
  width: 30%;
  padding-top: 100px;
}
.market-top .button {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 100px;
}
.market-top .button .registration {
  width: 70%;
}
.market-top .button .registration h2 {
  font-size: 1.4rem;
  margin-bottom: 10px;
}
.market-top .button .registration .checkbox {
  color: var(--pointColor);
  border-radius: 3px;
  position: relative;
  padding-left: 20px; /* 체크박스 왼쪽 여백 조절 */
  font-size: 0.7rem;
}
.market-top .button .registration .checkbox::before {
  content: "";
  position: absolute;
  left: 2px;
  top: 50%;
  transform: translateY(-48%);
  width: 10px; /* 체크표시의 가로 길이 조절 */
  height: 10px; /* 체크표시의 세로 길이 조절 */
  border: 1px solid var(--pointColor); /* 체크표시의 테두리 스타일과 색상 설정 */
  border-radius: 10px;
  background-color: transparent; /* 체크표시의 배경 색상 설정 */
  text-align: center;
}
.market-top .button .registration .checkbox.checked::before {
  content: "✓"; /* 유니코드로 체크마크 추가 */
  font-size: 8px; /* 체크마크의 크기 조절 */
  font-weight: bold;
  color: var(--pointColor); /* 체크마크의 색상 설정 */
  line-height: 10px;
}
.market-top .button > button {
  background-color: #222;
  color: #eee;
  padding: 9px 20px;
  width: 30%;
  height: 40px;
}
.market-top .selectedData {
  width: 100%;
}

.market-table {
  position: relative;
  width: 70%;
  z-index: 10;
}
.market-table .table-top {
  display: flex;
  justify-content: space-between;
  padding: 20px 10px 10px 10px;
}
.market-table .table-top .table-top-left {
  display: flex;
}
.market-table .table-top .table-top-left > p,
.market-table .table-top .table-top-left button:nth-of-type(1) {
  margin-right: 10px;
}
.market-table .table-top .table-top-right {
  display: flex;
}
.market-table table {
  table-layout: fixed;
  width: 100%;
  box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  border-radius: 5px;
}
.market-table table thead th {
  font-weight: 500;
  word-break: keep-all;
  white-space: nowrap;
}
.market-table table tr {
  transition: 0.5s;
}
.market-table table tr:hover {
  background-color: #eee;
}
.market-table table td,
.market-table table th {
  word-wrap: break-word;
  padding: 1em 0.5em;
  vertical-align: middle;
  box-sizing: border-box;
  text-align: center;
}
.market-table table th:nth-child(3) {
  min-width: 160px;
}
.market-table table th:nth-child(1) {
  min-width: 120px;
}
.market-table table tbody {
  position: relative;
  overflow: hidden;
}
.market-table table tbody .defaultTable {
  background: none;
}
.market-table table tbody .defaultTable td > div {
  padding: 50px 0;
}
.market-table table tbody .loading {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(49, 49, 49, 0.5);
}
.market-table table tbody .loading .loadingImg {
  display: block;
  animation: rotate 5s infinite;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.market-table table td {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.market-table table td .tdInput {
  display: flex;
}
.market-table table td .tdInput > input {
  width: 100%;
}

.marketRegistrationModal {
  position: fixed;
  right: 0;
  top: 0;
  width: 65%;
  height: 100vh;
  display: flex;
  justify-content: center;
  transition: 0.3s;
  background-color: #f3f3f3;
  z-index: 10;
}
.marketRegistrationModal .slide-modal-content {
  position: absolute;
  overflow-y: scroll;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 60px 10% 20px;
}
.marketRegistrationModal .slide-modal-content::-webkit-scrollbar {
  width: 10px; /* 스크롤바의 너비 */
  background-color: #f1f1f1;
}
.marketRegistrationModal .slide-modal-content::-webkit-scrollbar-thumb {
  width: 10px;
  background: #b6b6b6; /* 스크롤바의 색상 */
  border-radius: 10px;
}
.marketRegistrationModal .slide-modal-content::-webkit-scrollbar-track {
  background: #f3f3f3; /*스크롤바 뒷 배경 색상*/
}
.marketRegistrationModal .slide-modal-content .counters {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 40px;
  border-bottom: 0.5px solid #fff;
}
.marketRegistrationModal .slide-modal-content .counters span {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 25px;
  background-color: #333;
  color: #fff;
  text-align: center;
  line-height: 40px;
  transition: 0.3s;
  font-size: 1rem;
  font-weight: 300;
}
.marketRegistrationModal .slide-modal-content .counters span.on {
  background-color: var(--pointColor);
  color: #efefef;
}
.marketRegistrationModal .slide-modal-content .counters em {
  width: 100px;
  height: 2px;
  background-color: #333;
  transition: 0.3s;
}
.marketRegistrationModal .slide-modal-content .counters em.on {
  background-color: var(--pointColor);
}
.marketRegistrationModal .slide-modal-content .slides {
  width: 100%;
}
.marketRegistrationModal .slide-modal-content .slides .radioItem {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: 40px;
}
.marketRegistrationModal .slide-modal-content .slides .radioItem label {
  width: 30%;
  border: 1px solid #ccc;
  padding: 26px 0px;
  border-radius: 6px;
  transition: 0.3s;
  cursor: pointer;
}
.marketRegistrationModal .slide-modal-content .slides .radioItem label.on {
  border: 2px solid var(--pointColor);
  background-color: #f8f8f8;
}
.marketRegistrationModal .slide-modal-content .slides .radioItem label input {
  appearance: none;
  background-color: transparent;
  display: none;
}
.marketRegistrationModal .slide-modal-content .slides .radioItem label > span {
  display: block;
  width: 100%;
  text-align: center;
}
.marketRegistrationModal .slide-modal-content .slides > input {
  width: 100%;
  text-indent: 5px;
  margin-bottom: 20px;
}
.marketRegistrationModal .slide-modal-content .buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10%;
}
.marketRegistrationModal .slide-modal-content .buttons > button {
  width: 45%;
  padding: 10px 0;
}
.marketRegistrationModal .slide-modal-content .buttons > button.rightBtn, .marketRegistrationModal .slide-modal-content .buttons > button.taskRegistrationBtn, .marketRegistrationModal .slide-modal-content .buttons > button.registrationBtn {
  background-color: var(--pointColor);
  color: #fff;
}
.marketRegistrationModal .slide-modal-content .buttons > button.rightBtn:disabled, .marketRegistrationModal .slide-modal-content .buttons > button.taskRegistrationBtn:disabled {
  background-color: #f8f8f8;
  color: #999;
  cursor: auto;
}
.marketRegistrationModal .slide-modal-content .tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: 20px;
}
.marketRegistrationModal .slide-modal-content .tabs li {
  border: 1px solid rgba(0, 0, 0, 0.3);
  background-color: #f9f9f9;
  cursor: pointer;
  padding: 10px 14px;
  font-size: 0.8rem;
  transition: 0.3s;
}
.marketRegistrationModal .slide-modal-content .tabs li.active {
  background-color: #222;
  color: #eee;
}
.marketRegistrationModal .slide-modal-content .tables {
  padding-bottom: 30px;
}
.marketRegistrationModal .slide-modal-content .tables .tamplate-table {
  position: relative;
  width: 100%;
  height: auto;
}
.marketRegistrationModal .slide-modal-content .tables .tamplate-table > table {
  width: 100%;
  box-shadow: 0 0 1px 0px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  border-radius: 5px 0 0 5px;
  background-color: #f9f9f9;
}
.marketRegistrationModal .slide-modal-content .tables .tamplate-table > table th {
  background: #efefef;
  font-weight: 500;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.marketRegistrationModal .slide-modal-content .tables .tamplate-table > table td {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.marketRegistrationModal .slide-modal-content .updateButton {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 30px;
}
.marketRegistrationModal .slide-modal-content .updateButton > button {
  display: block;
  width: 140px;
  height: 45px;
}

h3 {
  font-size: 1rem;
  font-weight: 400;
  margin: 20px 0;
  position: relative;
}
h3 > span {
  padding-right: 20px;
}
h3 > span svg {
  color: #bbb;
  margin-left: 5px;
  margin-bottom: -2px;
  transition: 0.3s;
}
h3 > span.on svg {
  color: var(--pointColor);
}

.modal-content > h3 {
  margin-bottom: 40px;
  text-align: center;
}
.modal-content .modal-body {
  width: 100%;
  margin-bottom: 20px;
}
.modal-content .modal-body .modal-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
}
.modal-content .modal-body .modal-row .modal-column {
  margin-right: 10px;
}
.modal-content .modal-body .modal-row .modal-column:last-child {
  margin-right: 0px;
}
.modal-content .modal-body .modal-column {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 10px;
}
.modal-content .modal-body .modal-column .modal-column-row {
  display: flex;
  flex-direction: row;
  word-break: keep-all;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
}
.modal-content .modal-body .modal-column .modal-column-row > .key {
  margin-bottom: 0px;
  margin-right: 10px;
}
.modal-content .modal-body .modal-column span.key {
  font-weight: 600;
  font-size: 14px;
  color: #949494;
  text-indent: 10px;
  margin-bottom: 10px;
  position: relative;
}
.modal-content .modal-body .modal-column span.key::before {
  content: "";
  display: block;
  width: 2px;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  background-color: #ddd;
}
.modal-content .modal-body .modal-column span.value {
  display: flex;
  width: 100%;
  min-width: 160px;
  min-height: 34px;
  border: 1px solid #ddd;
  padding: 5px 10px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}

.proc {
  display: flex;
  margin: 80px 7vw 60px;
}
.proc > h2 {
  flex: 1 1;
  font-size: 3rem;
}
.proc .procBox {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.proc .procBox > h3 {
  color: #333;
  font-size: 1.4rem;
  margin-bottom: 30px;
}
.proc .procBox > button {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  width: 90%;
  height: 100px;
  text-align: left;
  border: none;
  box-shadow: none;
  background-color: transparent;
  font-size: 1rem;
  padding: 10px 20px 10px 10px;
}
.proc .procBox > button .button-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  color: var(--pointColor);
}
.proc .procBox > button .button-title .button-title-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.proc .procBox > button .button-title .button-title-left > svg {
  display: inline-block;
}
.proc .procBox > button .button-title .button-title-left > svg .special-rotate {
  transform-origin: 142px 47px;
  transform: scale(90%);
  transition: transform 0.5s ease;
}
.proc .procBox > button .button-title > span {
  transition: 0.3s;
}
.proc .procBox > button .button-title > span::before {
  content: "";
  border: solid black;
  border-width: 0.1em 0.1em 0 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
}
.proc .procBox > button > p {
  color: #666;
  font-size: 0.8rem;
}
.proc .procBox > button:hover {
  background-color: #f3f3f3;
}
.proc .procBox > button:hover .button-title {
  transition: 0.3s;
}
.proc .procBox > button:hover .button-title .button-title-left svg .special-rotate {
  transition: transform 0.2s ease;
  transform-origin: 142px 47px;
  transform: rotate(45deg) scale(90%);
  fill: var(--pointColor);
  stroke: var(--pointColor);
  opacity: 1;
}
.proc .procBox > button:hover .button-title > span {
  transform: translateX(5px);
}
.proc .procBox > button:hover .button-title > span::before {
  border: solid var(--pointColor);
  border-width: 0.1em 0.1em 0 0;
}

.layout {
  position: relative;
  padding: 20px;
  box-sizing: border-box;
  margin: 0 auto;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.disabled {
  color: #ccc;
  /* 텍스트 색상을 회색으로 설정 */
  pointer-events: none;
  /* 이벤트를 비활성화하여 클릭 및 이동을 막음 */
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./src/scss/common/_variable.scss","webpack://./src/scss/common/_header.scss","webpack://./src/scss/common/_footer.scss","webpack://./src/scss/common/_reset.scss","webpack://./src/scss/common/_checkbox.scss","webpack://./src/scss/common/_pagination.scss","webpack://./src/scss/sub/_subCommon.scss","webpack://./src/scss/sub/_order.scss","webpack://./src/scss/sub/_hub.scss","webpack://./src/scss/sub/_market.scss","webpack://./src/scss/sub/_proc.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACC,qBAAA;ADGD;;AEJA;EACC,kBAAA;EACA,UAAA;AFOD;AEJG;EACC,sBAAA;AFMJ;AEDI;EACC,wCAAA;AFGL;AEDI;EACC,aAAA;AFGL;AEDI;EACC,0CAAA;AFGL;;AEGA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;AFAD;AEEE;EACC,yBAAA;EACA,UAAA;AFAH;AEGC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AFDF;AEEE;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;AFAH;AEGC;EACC,UAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;AFDF;;AEKA;EACC,aAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AFFD;AEGC;EACC,SAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AFDF;AEEE;EACC,gBAAA;AFAH;AEEE;EACC,iBAAA;AFAH;AEEE;EACC,eAAA;EACA,qBAAA;EACA,eAAA;AFAH;AEGC;EACC,mCAAA;EACA,WAAA;AFDF;;AGvFA;EACC,WAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;AH0FD;;AI9FA;EACC,SAAA;EACA,UAAA;EACA,sBAAA;EACA,uCAAA;EACA,eAAA;AJiGD;;AI/FA;;;EAGC,gBAAA;AJkGD;;AIhGA;EACC,qBAAA;AJmGD;;AIjGA;EACC,YAAA;AJoGD;;AIlGA;;;EAIC,yBAAA;AJoGD;;AIlGA;;EAEC,aAAA;AJqGD;;AInGA;EACC,kBAAA;EACA,cAAA;EACA,UAAA;AJsGD;;AIpGA;EAEC,WAAA;EACA,SAAA;EACA,iBAAA;AJsGD;;AIhGA;EACC,+EAAA;AJmGD;;AK/IA;EACC,aAAA;ALkJD;AKjJC;EACC,YAAA;ALmJF;AKjJE;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;ALmJH;AKlJG;EACC,kBAAA;ALoJJ;AKnJI;EACC,WAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,sBAAA;EACA,eAAA;ALqJL;AKlJG;EACC,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,+BAAA;ALoJJ;;AMrLA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;ANwLD;AMtLC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;ANwLF;AMtLE;EAGC,sBAAA;EACA,0BAAA;ANsLH;AM/KG;EACC,qBAAA;EACA,eAAA;ANiLJ;AM7KE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AN+KH;;AOrNA;EACC,gBAAA;EACA,wBAAA;APwND;;AOtNA;EACC,gBAAA;EACA,wBAAA;EACA,eAAA;APyND;AOxNC;EACC,0BAAA;AP0NF;;AOvNA;;EAEC,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,8CAAA;EACA,eAAA;EACA,gBAAA;AP0ND;;AOvNA;EACC,oBAAA;AP0ND;;AOxNA;;EAEC,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,8CAAA;EACA,YAAA;AP2ND;AO1NC;;EACC,aAAA;AP6NF;;AO1NA;EACC,eAAA;EACA,+BAAA;AP6ND;;AO3NA;EACC,WAAA;EACA,aAAA;EACA,mBAAA;AP8ND;AO7NC;EACC,aAAA;EACA,uBAAA;EACA,QAAA;AP+NF;AO9NE;EACC,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;APgOH;AO9NI;EACC,sBAAA;APgOL;AO1NG;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AP4NJ;AO3NI;EACC,WAAA;EACA,iBAAA;AP6NL;AO1NG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AP4NJ;AO3NI;EACC,iBAAA;EACA,WAAA;AP6NL;AOxNK;EACC,WAAA;AP0NN;;AOjNC;EACC,0CAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;APoNF;AOjNC;EACC,gBAAA;EACA,gBAAA;APmNF;AOhNC;EACC,iBAAA;EACA,WAAA;EACA,6BAAA;APkNF;AOhNC;;EAEC,kBAAA;EACA,sBAAA;EACA,oBAAA;APkNF;AO9ME;EACC,2CAAA;EACA,gBAAA;APgNH;AO7MG;EACC,YAAA;AP+MJ;AO3MC;EACC,aAAA;EACA,uBAAA;EACA,eAAA;AP6MF;AO5ME;EACC,qBAAA;EACA,kBAAA;EACA,aAAA;AP8MH;AO7MG;EACC,cAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;AP+MJ;AO9MI;EACC,iBAAA;APgNL;AO9MI;EACC,gBAAA;APgNL;AO9MI;EACC,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;APgNL;AO5ME;EACC,WAAA;EACA,mCAAA;AP8MH;;AO1MA;EACC,qBAAA;EACA,kBAAA;EACA,aAAA;AP6MD;AO5MC;EACC,cAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;AP8MF;AO7ME;EACC,iBAAA;AP+MH;AO7ME;EACC,gBAAA;AP+MH;AO7ME;EACC,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;AP+MH;;AO1MA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AP6MD;AO5MC;EACC,aAAA;AP8MF;AO7ME;EACC,mCAAA;EACA,WAAA;AP+MH;AO5MC;EACC,aAAA;EACA,iBAAA;AP8MF;AO5MG;EACC,gBAAA;AP8MJ;AO5MG;EACC,YAAA;EACA,kBAAA;EACA,8CAAA;EACA,aAAA;AP8MJ;AO5MK;EAEC,YAAA;AP6MN;AO1MI;EACC,gBAAA;EACA,QAAA;AP4ML;AOvMK;EACC,yBAAA;EACA,kBAAA;EACA,SAAA;APyMN;AOrMK;EACC,sBAAA;EACA,mBAAA;EACA,cAAA;APuMN;AOtMM;EACC,mBAAA;EACA,oBAAA;APwMP;AOrMO;EACC,eAAA;APuMR;AOjMO;EACC,kBAAA;EACA,gBAAA;APmMR;AOlMQ;EACC,iDAAA;APoMT;AOjMO;EACC,wBAAA;EACA,0BAAA;APmMR;AOjMO;EACC,mCAAA;APmMR;AOjMO;EACC,mDAAA;APmMR;AO3LC;EACC,kBAAA;AP6LF;AO5LE;EACC,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,8CAAA;EACA,iBAAA;EACA,iBAAA;AP8LH;AO5LE;EACC,WAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4EAAA;AP8LH;;AO1LA;EACC,kBAAA;AP6LD;AO5LC;EACC,aAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AP8LF;AO7LE;EACC,iBAAA;AP+LH;AO7LE;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AP+LH;AO5LC;EAEC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AP6LF;AO5LE;EACC,cAAA;AP8LH;AO5LE;EACC,kBAAA,EAAA,uBAAA;EACA,eAAA;EACA,SAAA,EAAA,oBAAA;EACA,OAAA;EACA,UAAA,EAAA,sBAAA;EACA,aAAA,EAAA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AP8LH;AO7LG;EACC,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AP+LJ;AO9LI;EACC,cAAA;EACA,mCAAA;APgML;AO9LI;EACC,cAAA;EACA,WAAA;APgML;;AO1LA;;EAEC,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;AP6LD;AO5LC;;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AP+LF;AO9LE;;EACC,eAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,4BAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;APiMH;AOhMG;;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;APmMJ;AOjMG;;EACC,eAAA;EACA,cAAA;APoMJ;AOjME;;EACC,eAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;APoMH;AOnMG;;EACC,WAAA,EAAA,aAAA;EACA,yBAAA;APsMJ;AOpMG;;EACC,UAAA;EACA,WAAA,EAAA,aAAA;EACA,mBAAA,EAAA,aAAA;EACA,mBAAA;APuMJ;AOrMG;;EACC,gBAAA,EAAA,eAAA;EACA,4BAAA;EACA,sBAAA;APwMJ;AOtMG;;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;APyMJ;AOxMI;;EACC,kBAAA;AP2ML;AO1MK;;EACC,iBAAA;AP6MN;AO1MI;;EACC,mBAAA;AP6ML;AO5MK;;EACC,SAAA;EACA,aAAA;EACA,sBAAA;AP+MN;AO9MM;;EACC,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;APiNP;AOhNO;;EACC,qBAAA;EACA,WAAA;APmNR;AO/MK;;EACC,YAAA;APkNN;AO9MG;;EACC,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;APiNJ;AO/MG;;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;APkNJ;AOjNI;;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;APoNL;AOnNK;;EACC,kBAAA;EACA,kBAAA;APsNN;AOnNI;;EACC,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;APsNL;AOrNK;;EACC,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;APwNN;AOtNK;;EACC,aAAA;APyNN;AOtNI;;EACC,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;APyNL;AOxNK;;EACC,qBAAA;EACA,WAAA;AP2NN;AOzNK;;EACC,YAAA;AP4NN;AO3NM;;EAKC,SAAA;EACA,eAAA;EACA,iBAAA;AP0NP;AOhOO;;EACC,SAAA;EACA,4BAAA;APmOR;AO5NK;;EACC,8BAAA;AP+NN;AO9NM;;EACC,iBAAA;APiOP;AO1NC;;EACC,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AP6NF;AO5NE;;EACC,mBAAA;AP+NH;AO9NG;;;EAEC,sBAAA;APiOJ;AO9NE;;;EAEC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA,EAAA,cAAA;EACA,mBAAA,EAAA,cAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;APiOH;AO9NE;;EACC,wBAAA;APiOH;AO9NE;;EACC,yBAAA;APiOH;AO9NC;;EACC,gBAAA;EACA,oBAAA;APiOF;AOhOE;;EACC,YAAA;APmOH;;AO9NA;EACC,iCAAA;APiOD;;AO/NA;EACC,YAAA;APkOD;AOhOC;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;APkOF;AOjOE;EACC,kBAAA;APmOH;AOlOG;EACC,WAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,sBAAA;EACA,eAAA;APoOJ;AOjOE;EACC,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;APmOH;;AO/NA;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;APkOD;AOjOC;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;APmOF;AOlOE;EACC,iBAAA;EACA,mBAAA;EACA,sBAAA;APoOH;AOlOE;EACC,+BAAA;APoOH;;AQv3BA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;AR03BD;AQx3BC;EACC,aAAA;EACA,8BAAA;EACA,4BAAA;AR03BF;AQz3BE;EACC,aAAA;AR23BH;AQ13BG;;EAEC,kBAAA;AR43BJ;AQz3BE;EACC,aAAA;AR23BH;AQx3BC;EACC,mBAAA;EACA,WAAA;EACA,0CAAA;EACA,yBAAA;EACA,kBAAA;AR03BF;AQz3BE;EACC,mBAAA;AR23BH;AQ13BG;EACC,gBAAA;EACA,oBAAA;EACA,mBAAA;AR43BJ;AQz3BE;EACC,gBAAA;AR23BH;AQ13BG;EACC,sBAAA;AR43BJ;AQz3BE;;EAEC,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AR23BH;AQz3BE;EACC,YAAA;EACA,gBAAA;AR23BH;AQz3BE;EACC,YAAA;EACA,gBAAA;AR23BH;AQz3BE;EACC,kBAAA;EACA,gBAAA;AR23BH;AQ13BG;EACC,gBAAA;AR43BJ;AQ13BK;EACC,eAAA;AR43BN;AQx3BG;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;AR03BJ;AQz3BI;EACC,cAAA;EASA,6BAAA;ARm3BL;AQ33BK;EACC;IACC,uBAAA;ER63BL;EQ33BI;IACC,yBAAA;ER63BL;AACF;AQv3BE;EACC,oCAAA;ARy3BH;AQx3BG;EACC,aAAA;AR03BJ;AQz3BI;EACC,WAAA;AR23BL;AQx3BG;EACC,aAAA;EACA,mBAAA;AR03BJ;;AQr3BA;EACC,eAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,UAAA;ARw3BD;;AQt3BA;EACC,eAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;ARy3BD;;ASh/BA;EACC,aAAA;ATm/BD;ASl/BC;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;ATo/BF;ASl/BG;EACC,qBAAA;EACA,kBAAA;ATo/BJ;ASl/BG;EACC,aAAA;EACA,2BAAA;ATo/BJ;ASh/BG;EACC,YAAA;ATk/BJ;AS7+BG;EACC,kBAAA;AT++BJ;;AS1+BA;EACC,aAAA;AT6+BD;AS5+BC;EACC,iBAAA;AT8+BF;;AS3+BA;EACC,kBAAA;EACA,WAAA;AT8+BD;AS5+BC;EACC,YAAA,EAAA,aAAA;EACA,yBAAA;AT8+BF;AS5+BC;EACC,UAAA;EACA,WAAA,EAAA,aAAA;EACA,mBAAA,EAAA,aAAA;EACA,mBAAA;AT8+BF;AS5+BC;EACC,gBAAA,EAAA,eAAA;EACA,4BAAA;EACA,sBAAA;AT8+BF;AS5+BC;EACC,aAAA;EACA,8BAAA;EACA,4BAAA;AT8+BF;AS7+BE;EACC,aAAA;AT++BH;AS7+BE;EACC,aAAA;AT++BH;AS5+BC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,0CAAA;EACA,yBAAA;EACA,kBAAA;AT8+BF;AS7+BE;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AT++BH;AS9+BG;EACC,WAAA;EACA,0CAAA;EACA,yBAAA;EACA,0BAAA;ATg/BJ;AS/+BI;EACC,mBAAA;ATi/BL;ASh/BK;EACC,gBAAA;ATk/BN;AS/+BI;EACC,kBAAA;ATi/BL;AS7+BE;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EAEA,gBAAA;EACA,kBAAA;AT8+BH;AS7+BG;EACC,WAAA,EAAA,aAAA;EACA,YAAA;EACA,yBAAA;AT++BJ;AS7+BG;EACC,UAAA;EACA,WAAA,EAAA,aAAA;EACA,mBAAA,EAAA,aAAA;EACA,mBAAA;AT++BJ;AS7+BG;EACC,gBAAA,EAAA,eAAA;EACA,4BAAA;EACA,sBAAA;AT++BJ;AS5+BE;EACC,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,yBAAA;EACA,0BAAA;AT8+BH;AS7+BG;EACC,mBAAA;AT++BJ;AS7+BK;EACC,YAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AT++BN;AS3+BG;EACC,kBAAA;AT6+BJ;AS5+BI;EACC,gBAAA;AT8+BL;AS1+BK;EACC,YAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;AT4+BN;ASz+BI;EACC,gBAAA;AT2+BL;AS1+BK;EACC,gBAAA;EACA,iBAAA;AT4+BN;AS3+BM;EACC,eAAA;AT6+BP;;ASr+BA;;EAEC,WAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,iBAAA;ATw+BD;ASv+BC;;EACC,iCAAA;AT0+BF;ASv+BC;;EACC,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,SAAA;EACA,4BAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AT0+BF;ASx+BE;;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,4BAAA;EACA,gCAAA;EACA,mBAAA;EACA,UAAA;AT2+BH;AS1+BG;;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AT6+BJ;AS3+BG;;EACC,eAAA;EACA,cAAA;AT8+BJ;AS3+BE;;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AT8+BH;AS7+BG;;EACC,mBAAA;ATg/BJ;AS/+BI;;;EAEC,sBAAA;ATk/BL;AS/+BG;;;EAEC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA,EAAA,cAAA;EACA,mBAAA,EAAA,cAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;ATk/BJ;AS/+BG;;EACC,wBAAA;ATk/BJ;AS/+BG;;EACC,yBAAA;ATk/BJ;AS/+BE;;EACC,oBAAA;ATk/BH;ASh/BE;;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;ATm/BH;ASl/BG;;EACC,WAAA,EAAA,aAAA;EACA,YAAA;EACA,yBAAA;ATq/BJ;ASn/BG;;EACC,UAAA;EACA,WAAA,EAAA,aAAA;EACA,mBAAA,EAAA,aAAA;EACA,mBAAA;ATs/BJ;ASp/BG;;EACC,gBAAA,EAAA,eAAA;EACA,4BAAA;EACA,sBAAA;ATu/BJ;ASp/BG;;EACC,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;ATu/BJ;ASt/BI;;EACC,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;ATy/BL;ASx/BK;;EACC,UAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AT2/BN;AS1/BM;;EACC,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AT6/BP;AS5/BO;;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AT+/BR;AS3/BK;;EACC,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;AT8/BN;AS7/BM;;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ATggCP;AS5/BI;;EACC,UAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AT+/BL;AS5/BG;;EACC,mBAAA;EACA,kBAAA;EACA,WAAA;AT+/BJ;AS9/BI;;EACC,aAAA;EACA,8BAAA;ATigCL;AShgCK;;EACC,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;ATmgCN;ASlgCM;;EACC,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;ATqgCP;ASlgCK;;EACC,aAAA;EACA,YAAA;ATqgCN;ASpgCM;;EACC,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ATugCP;AStgCO;;EACC,cAAA;EACA,iBAAA;EACA,kBAAA;ATygCR;ASxgCQ;;EACC,eAAA;EACA,YAAA;AT2gCT;ASvgCM;;EACC,iBAAA;AT0gCP;ASzgCO;;EACC,iBAAA;AT4gCR;ASvgCI;;EACC,WAAA;AT0gCL;ASzgCK;;EACC,YAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,0CAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AT4gCN;ASzgCI;;EACC,cAAA;AT4gCL;AS1gCI;;;;EAEC,WAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;AT8gCL;AS7gCK;;;;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;ATkhCN;ASjhCM;;;;EACC,eAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;ATshCP;ASrhCO;;;;EACC,gBAAA;EACA,eAAA;EACA,cAAA;AT0hCR;ASvhCM;;;;EACC,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;AT4hCP;AS3hCO;;;;EACC,WAAA,EAAA,aAAA;EACA,yBAAA;ATgiCR;AS9hCO;;;;EACC,UAAA;EACA,WAAA,EAAA,aAAA;EACA,mBAAA,EAAA,aAAA;EACA,mBAAA;ATmiCR;ASjiCO;;;;EACC,gBAAA,EAAA,eAAA;EACA,4BAAA;EACA,sBAAA;ATsiCR;ASliCK;;;;EACC,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;ATuiCN;AStiCM;;;;EACC,mBAAA;AT2iCP;AS1iCO;;;;;;;EAEC,sBAAA;ATijCR;AS9iCM;;;;;;;EAEC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA,EAAA,cAAA;EACA,mBAAA,EAAA,cAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;ATqjCP;ASljCM;;;;EACC,wBAAA;ATujCP;ASpjCM;;;;EACC,yBAAA;ATyjCP;ASnjCG;;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;ATsjCJ;ASrjCI;;EACC,kBAAA;ATwjCL;ASvjCK;;EACC,iBAAA;AT0jCN;AStjCG;;EACC,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;ATyjCJ;ASvjCG;;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AT0jCJ;ASzjCI;;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AT4jCL;AS3jCK;;EACC,kBAAA;EACA,kBAAA;AT8jCN;AS1jCI;;EACC,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AT6jCL;AS5jCK;;EACC,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;AT+jCN;AS7jCK;;EACC,aAAA;ATgkCN;AS7jCI;;EACC,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;ATgkCL;AS/jCK;;EACC,qBAAA;EACA,WAAA;ATkkCN;AShkCK;;EACC,YAAA;ATmkCN;ASlkCM;;EAKC,SAAA;EACA,eAAA;EACA,iBAAA;ATikCP;ASvkCO;;EACC,SAAA;EACA,4BAAA;AT0kCR;ASnkCK;;EACC,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ATskCN;ASrkCM;;EACC,cAAA;EACA,iBAAA;EACA,kBAAA;ATwkCP;ASvkCO;;EACC,eAAA;EACA,YAAA;AT0kCR;ASrkCI;;EACC,kBAAA;EACA,WAAA;EACA,MAAA;ATwkCL;;ASlkCA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;EACA,gBAAA;ATqkCD;ASpkCC;EACC,uBAAA;ATskCF;ASnkCE;EACC,kBAAA;ATqkCH;ASlkCC;EACC,gBAAA;EACA,qCAAA;ATokCF;ASlkCC;EACC,cAAA;EASA,6BAAA;AT4jCF;ASpkCE;EACC;IACC,uBAAA;ETskCF;ESpkCC;IACC,yBAAA;ETskCF;AACF;;AU3tDA;EACC,aAAA;EACA,aAAA;EACA,OAAA;AV8tDD;;AU5tDA;EACC,UAAA;EACA,kBAAA;AV+tDD;AU9tDC;EACC,aAAA;EACA,eAAA;EACA,8BAAA;EACA,oBAAA;AVguDF;AU/tDE;EACC,UAAA;AViuDH;AUhuDG;EACC,iBAAA;EACA,mBAAA;AVkuDJ;AUhuDG;EACC,wBAAA;EACA,kBAAA;EAGA,kBAAA;EACA,kBAAA,EAAA,kBAAA;EACA,iBAAA;AVguDJ;AU/tDI;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA,EAAA,mBAAA;EACA,YAAA,EAAA,mBAAA;EACA,mCAAA,EAAA,yBAAA;EACA,mBAAA;EACA,6BAAA,EAAA,mBAAA;EACA,kBAAA;AViuDL;AU/tDI;EACC,YAAA,EAAA,kBAAA;EACA,cAAA,EAAA,gBAAA;EACA,iBAAA;EACA,wBAAA,EAAA,gBAAA;EACA,iBAAA;AViuDL;AU7tDE;EACC,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;AV+tDH;AU3tDC;EACC,WAAA;AV6tDF;;AU1tDA;EACC,kBAAA;EACA,UAAA;EACA,WAAA;AV6tDD;AU5tDC;EACC,aAAA;EACA,8BAAA;EACA,4BAAA;AV8tDF;AU7tDE;EACC,aAAA;AV+tDH;AU9tDG;;EAEC,kBAAA;AVguDJ;AU7tDE;EACC,aAAA;AV+tDH;AU5tDC;EACC,mBAAA;EACA,WAAA;EACA,0CAAA;EACA,yBAAA;EACA,kBAAA;AV8tDF;AU5tDG;EACC,gBAAA;EACA,oBAAA;EACA,mBAAA;AV8tDJ;AU3tDE;EACC,gBAAA;AV6tDH;AU5tDG;EACC,sBAAA;AV8tDJ;AU3tDE;;EAEC,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AV6tDH;AU3tDE;EACC,gBAAA;AV6tDH;AU3tDE;EACC,gBAAA;AV6tDH;AU3tDE;EACC,kBAAA;EACA,gBAAA;AV6tDH;AU5tDG;EACC,gBAAA;AV8tDJ;AU5tDK;EACC,eAAA;AV8tDN;AU1tDG;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;AV4tDJ;AU3tDI;EACC,cAAA;EASA,6BAAA;AVqtDL;AU7tDK;EACC;IACC,uBAAA;EV+tDL;EU7tDI;IACC,yBAAA;EV+tDL;AACF;AUztDE;EACC,oCAAA;AV2tDH;AU1tDG;EACC,aAAA;AV4tDJ;AU3tDI;EACC,WAAA;AV6tDL;;AUttDA;EACC,eAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AVytDD;AUvtDC;EACC,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AVytDF;AUxtDE;EACC,WAAA,EAAA,aAAA;EACA,yBAAA;AV0tDH;AUxtDE;EACC,WAAA;EACA,mBAAA,EAAA,aAAA;EACA,mBAAA;AV0tDH;AUxtDE;EACC,mBAAA,EAAA,eAAA;AV0tDH;AUxtDE;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,+BAAA;AV0tDH;AUztDG;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AV2tDJ;AU1tDI;EACC,mCAAA;EACA,cAAA;AV4tDL;AUztDG;EACC,YAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AV2tDJ;AU1tDI;EACC,mCAAA;AV4tDL;AUxtDE;EACC,WAAA;AV0tDH;AUztDG;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AV2tDJ;AU1tDI;EACC,UAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AV4tDL;AU3tDK;EACC,mCAAA;EACA,yBAAA;AV6tDN;AU3tDK;EAGC,gBAAA;EACA,6BAAA;EACA,aAAA;AV6tDN;AU3tDK;EACC,cAAA;EACA,WAAA;EACA,kBAAA;AV6tDN;AUztDG;EACC,WAAA;EACA,gBAAA;EACA,mBAAA;AV2tDJ;AUxtDE;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;AV0tDH;AUztDG;EACC,UAAA;EACA,eAAA;AV2tDJ;AU1tDI;EAGC,mCAAA;EACA,WAAA;AV0tDL;AUxtDI;EAEC,yBAAA;EACA,WAAA;EACA,YAAA;AVytDL;AUrtDE;EACC,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AVutDH;AUttDG;EACC,oCAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AVwtDJ;AUvtDI;EACC,sBAAA;EACA,WAAA;AVytDL;AUrtDE;EACC,oBAAA;AVutDH;AUttDG;EACC,kBAAA;EACA,WAAA;EACA,YAAA;AVwtDJ;AUvtDI;EACC,WAAA;EACA,0CAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;AVytDL;AUxtDK;EACC,mBAAA;EACA,gBAAA;EACA,oCAAA;AV0tDN;AUxtDK;EACC,oCAAA;AV0tDN;AUrtDE;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;AVutDH;AUttDG;EACC,cAAA;EACA,YAAA;EACA,YAAA;AVwtDJ;;AUhtDA;EACC,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AVmtDD;AUvsDC;EACC,mBAAA;AVysDF;AUxsDE;EACC,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AV0sDH;AUvsDG;EACC,wBAAA;AVysDJ;;AUlsDC;EACC,mBAAA;EACA,kBAAA;AVqsDF;AUnsDC;EACC,WAAA;EACA,mBAAA;AVqsDF;AUpsDE;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AVssDH;AUrsDG;EACC,kBAAA;AVusDJ;AUtsDI;EACC,iBAAA;AVwsDL;AUpsDE;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AVssDH;AUrsDG;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AVusDJ;AUtsDI;EACC,kBAAA;EACA,kBAAA;AVwsDL;AUrsDG;EACC,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AVusDJ;AUtsDI;EACC,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;AVwsDL;AUrsDG;EACC,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;EACA,yBAAA;AVusDJ;;AWhoEA;EACC,aAAA;EACA,qBAAA;AXmoED;AWloEC;EACC,SAAA;EACA,eAAA;AXooEF;AWloEC;EACC,SAAA;EACA,aAAA;EACA,sBAAA;AXooEF;AWnoEE;EACC,WAAA;EACA,iBAAA;EACA,mBAAA;AXqoEH;AWnoEE;EACC,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,4BAAA;AXqoEH;AWpoEG;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,wBAAA;AXsoEJ;AWroEI;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AXuoEL;AWtoEK;EACC,qBAAA;AXwoEN;AWvoEM;EACC,4BAAA;EACA,qBAAA;EACA,+BAAA;AXyoEP;AWroEI;EACC,gBAAA;AXuoEL;AWtoEK;EACC,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,YAAA;EACA,wBAAA;AXwoEN;AWpoEG;EACC,WAAA;EACA,iBAAA;AXsoEJ;AWpoEG;EACC,yBAAA;AXsoEJ;AWroEI;EACC,gBAAA;AXuoEL;AWpoEO;EACC,+BAAA;EACA,4BAAA;EACA,mCAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;AXsoER;AWloEK;EACC,0BAAA;AXooEN;AWnoEM;EACC,+BAAA;EACA,6BAAA;AXqoEP;;AA3sEA;EACC,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AA8sED;;AA1sEA;EACC,kBAAA;AA6sED;;AA1sEA;EACC,cAAA;EACA,oBAAA;AA6sED;;AA1sEA;EACC;IACC,4CAAA;EA6sEA;AACF;AA1sEA;EACC,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AA4sED;;AAzsEA;EACC,cAAA;AA4sED;;AAzsEA;EACC,WAAA;EACA,oBAAA;EACA,oBAAA;EACA,4BAAA;AA4sED;;AAzsEA;EACC;IACC,uBAAA;EA4sEA;EAzsED;IACC,yBAAA;EA2sEA;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;600;700&display=swap');\n\n@import 'common/variable';\n@import 'common/header';\n@import 'common/footer';\n@import 'common/reset';\n@import 'common/checkbox';\n@import 'common/pagination';\n\n@import 'sub/subCommon';\n@import 'sub/order';\n@import 'sub/hub';\n@import 'sub/market';\n@import 'sub/proc';\n\n.layout {\n\tposition: relative;\n\tpadding: 20px;\n\tbox-sizing: border-box;\n\tmargin: 0 auto;\n}\n\n//App.css\n.App {\n\ttext-align: center;\n}\n\n.App-logo {\n\theight: 40vmin;\n\tpointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n\t.App-logo {\n\t\tanimation: App-logo-spin infinite 20s linear;\n\t}\n}\n\n.App-header {\n\tbackground-color: #282c34;\n\tmin-height: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: calc(10px + 2vmin);\n\tcolor: white;\n}\n\n.App-link {\n\tcolor: #61dafb;\n}\n\n.disabled {\n\tcolor: #ccc;\n\t/* 텍스트 색상을 회색으로 설정 */\n\tpointer-events: none;\n\t/* 이벤트를 비활성화하여 클릭 및 이동을 막음 */\n}\n\n@keyframes App-logo-spin {\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n}",":root {\n\t--pointColor: #463dc9;\n}\n",".IsProc {\n\tposition: relative;\n\tz-index: 1;\n\t.bars {\n\t\t> span:nth-of-type(2) {\n\t\t\t.bar {\n\t\t\t\tbackground-color: #eee;\n\t\t\t}\n\t\t}\n\t\t&.hover {\n\t\t\t> span:nth-of-type(2) {\n\t\t\t\t.bar:nth-child(1) {\n\t\t\t\t\ttransform: rotate(45deg) translateY(5px);\n\t\t\t\t}\n\t\t\t\t.bar:nth-child(2) {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t\t.bar:nth-child(3) {\n\t\t\t\t\ttransform: rotate(-45deg) translateY(-5px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.bars {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\t&:hover {\n\t\t> span:nth-of-type(1) {\n\t\t\ttransform: translateX(0%);\n\t\t\topacity: 1;\n\t\t}\n\t}\n\t> span:nth-of-type(2) {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 30px;\n\t\tmargin-left: 10px;\n\t\t.bar {\n\t\t\twidth: 100%;\n\t\t\tmargin: 3px 0;\n\t\t\tbackground-color: #222;\n\t\t\theight: 2px;\n\t\t\tborder-radius: 1.5px;\n\t\t\ttransition: 0.3s;\n\t\t}\n\t}\n\t> span:nth-of-type(1) {\n\t\topacity: 0;\n\t\ttransform: translateX(50%);\n\t\ttransition: 0.3s;\n\t\tfont-weight: normal;\n\t}\n}\n\n.logoutButton {\n\tdisplay: flex;\n\twidth: 100px;\n\theight: 30px;\n\tborder: none;\n\tborder-radius: 15px;\n\ttransition: 0.3s;\n\tmargin-right: 10px;\n\talign-items: center;\n\t> span {\n\t\tflex: 1;\n\t\tdisplay: block;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-around;\n\t\theight: 80%;\n\t\tfont-size: 0.8rem;\n\t\ttext-align: center;\n\t\t&:nth-child(1) {\n\t\t\tmargin-left: 7px;\n\t\t}\n\t\t&:nth-child(2) {\n\t\t\ttext-align: right;\n\t\t}\n\t\t> img {\n\t\t\tmargin-top: 2px;\n\t\t\tdisplay: inline-block;\n\t\t\theight: inherit;\n\t\t}\n\t}\n\t&:hover {\n\t\tbackground-color: var(--pointColor);\n\t\tcolor: #eee;\n\t}\n}\n",".footer {\n\twidth: 100%;\n\theight: calc(100vh - 662px);\n\tbackground-color: #222;\n\tcolor: #eee;\n}\n","* {\n\tmargin: 0;\n\tpadding: 0;\n\tbox-sizing: border-box;\n\tfont-family: 'Noto Sans KR', sans-serif;\n\tfont-size: 16px;\n}\nul,\nol,\nli {\n\tlist-style: none;\n}\na {\n\ttext-decoration: none;\n}\nfieldset {\n\tborder: none;\n}\ntable,\nth,\ntd {\n\t//border: 1px solid black;\n\tborder-collapse: collapse;\n}\nth,\ntd {\n\tpadding: 15px;\n}\n.h {\n\tposition: absolute;\n\ttop: -999999px;\n\topacity: 0;\n}\nbody {\n\t//background: #efefef;\n\tcolor: #222;\n\tmargin: 0;\n\tmin-width: 1200px;\n\t// font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',\n\t// \t'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n\t// -webkit-font-smoothing: antialiased;\n\t// -moz-osx-font-smoothing: grayscale;\n}\ncode {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n",".checkbox {\n\tdisplay: flex;\n\t.checkboxItem {\n\t\tpadding: 5px;\n\n\t\t> label {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\talign-items: center;\n\t\t\tflex-wrap: nowrap;\n\t\t\tword-break: keep-all;\n\t\t\tcursor: pointer;\n\t\t\tposition: relative;\n\t\t\t&.sale {\n\t\t\t\tmargin-right: 20px;\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\twidth: 2px;\n\t\t\t\t\theight: 14px;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: -15px;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\ttransform: translateY(-44%);\n\t\t\t\t\tbackground-color: #ccc;\n\t\t\t\t\tcursor: default;\n\t\t\t\t}\n\t\t\t}\n\t\t\t> input[type='checkbox'] {\n\t\t\t\tcursor: pointer;\n\t\t\t\tdisplay: block;\n\t\t\t\tmargin-right: 5px;\n\t\t\t\tmargin-bottom: -3px;\n\t\t\t\taccent-color: var(--pointColor);\n\t\t\t}\n\t\t}\n\t}\n}\n",".pagination {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 5px;\n\tmargin: 50px auto;\n\tpadding-bottom: 50px;\n\n\tli {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tborder-radius: 50%;\n\t\ttransition: all 0.3s;\n\n\t\t&:hover,\n\t\t&:active,\n\t\t&.active {\n\t\t\tbackground-color: #eee;\n\t\t\ttext-decoration: underline;\n\t\t}\n\n\t\t&:nth-child(1),\n\t\t&:nth-child(2),\n\t\t&:nth-last-child(1),\n\t\t&:nth-last-child(2) {\n\t\t\ta {\n\t\t\t\talign-items: baseline;\n\t\t\t\tfont-size: 20px;\n\t\t\t}\n\t\t}\n\n\t\ta {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tfont-size: 12px;\n\t\t\tcolor: #333;\n\t\t}\n\t}\n}\n",".pointText {\n\tfont-weight: 500;\n\tcolor: var(--pointColor);\n}\nspan.clickTd {\n\ttransition: 0.5s;\n\tcolor: var(--pointColor);\n\tcursor: pointer;\n\t&:hover {\n\t\ttext-decoration: underline;\n\t}\n}\nbutton,\ninput[type='button'] {\n\tfont-size: 0.8rem;\n\tpadding: 4px 10px;\n\tbackground-color: #fff;\n\tborder: none;\n\tborder-radius: 2px;\n\tbox-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);\n\tcursor: pointer;\n\ttransition: 0.3s;\n}\n\nbutton {\n\tword-break: keep-all;\n}\ninput[type='text'],\ntextarea {\n\tmin-height: 30px;\n\tborder: none;\n\tborder-radius: 2px;\n\tbox-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);\n\tpadding: 5px;\n\t&:focus {\n\t\toutline: none;\n\t}\n}\ninput[type='checkbox'] {\n\tcursor: pointer;\n\taccent-color: var(--pointColor);\n}\n.countBox {\n\twidth: 100%;\n\tpadding: 10px;\n\tmargin-bottom: 15px;\n\t> ul {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tgap: 3vw;\n\t\t> li {\n\t\t\tdisplay: flex;\n\t\t\twidth: calc(100 / 6);\n\t\t\tflex-direction: row;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\t\t\tpadding: 10px;\n\t\t\tbox-sizing: border-box;\n\t\t\ttransition: 0.5s;\n\t\t\tmargin-right: 10px;\n\t\t\t&:hover {\n\t\t\t\t.countIcon {\n\t\t\t\t\tbackground-color: #bbb;\n\t\t\t\t\t// > img {\n\t\t\t\t\t// \tfilter: invert(100%);\n\t\t\t\t\t// }\n\t\t\t\t}\n\t\t\t}\n\t\t\t.countIcon {\n\t\t\t\twidth: 50px;\n\t\t\t\theight: 50px;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tbackground-color: #f5f5f5;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\tmargin-right: 5px;\n\t\t\t\ttransition: 0.3s;\n\t\t\t\t> img {\n\t\t\t\t\twidth: 30px;\n\t\t\t\t\tobject-fit: cover;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.countText {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t\tspan > strong {\n\t\t\t\t\tfont-size: 1.2rem;\n\t\t\t\t\tcolor: #333;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:nth-child(5) {\n\t\t\t\t.countIcon {\n\t\t\t\t\t> img {\n\t\t\t\t\t\twidth: 25px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.searchForm {\n\ttable {\n\t\tbox-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);\n\t\twidth: 100%;\n\t\tborder-collapse: collapse;\n\t\tborder-radius: 5px;\n\t\tpadding: 10px;\n\t}\n\n\tth {\n\t\tfont-weight: 500;\n\t\ttext-align: left;\n\t}\n\n\tthead {\n\t\tfont-weight: bold;\n\t\tcolor: #fff;\n\t\tbackground: var(--pointColor);\n\t}\n\ttd,\n\tth {\n\t\tpadding: 1em 1.5em;\n\t\tvertical-align: middle;\n\t\tword-break: keep-all;\n\t}\n\n\ttr {\n\t\ttd {\n\t\t\tborder-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\t\t\ttransition: 0.3s;\n\t\t}\n\t\t&:last-child {\n\t\t\ttd {\n\t\t\t\tborder: none;\n\t\t\t}\n\t\t}\n\t}\n\t.searchBottonBox {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tpadding: 30px 0;\n\t\t> button:nth-of-type(1) {\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-right: 10px;\n\t\t\tdisplay: flex;\n\t\t\t> span {\n\t\t\t\tdisplay: block;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-around;\n\t\t\t\tfont-size: 0.8rem;\n\t\t\t\ttext-align: center;\n\t\t\t\t&:nth-child(1) {\n\t\t\t\t\ttext-align: right;\n\t\t\t\t}\n\t\t\t\t&:nth-child(2) {\n\t\t\t\t\tmargin-left: 3px;\n\t\t\t\t}\n\t\t\t\t> img {\n\t\t\t\t\tmargin-top: 2px;\n\t\t\t\t\tmargin-left: -2px;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\theight: 18px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t> button:nth-of-type(2) {\n\t\t\tcolor: #fff;\n\t\t\tbackground-color: var(--pointColor);\n\t\t}\n\t}\n}\n.resetIconButton {\n\tdisplay: inline-block;\n\tmargin-right: 10px;\n\tdisplay: flex;\n\t> span {\n\t\tdisplay: block;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-around;\n\t\tfont-size: 0.8rem;\n\t\ttext-align: center;\n\t\t&:nth-child(1) {\n\t\t\ttext-align: right;\n\t\t}\n\t\t&:nth-child(2) {\n\t\t\tmargin-left: 3px;\n\t\t}\n\t\t> img {\n\t\t\tmargin-top: 2px;\n\t\t\tmargin-left: -2px;\n\t\t\tdisplay: inline-block;\n\t\t\theight: 18px;\n\t\t}\n\t}\n}\n\n.datePickerBox {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 16px;\n\tinput[type='button'] {\n\t\tmargin: 0 2px;\n\t\t&.isActive {\n\t\t\tbackground-color: var(--pointColor);\n\t\t\tcolor: #eee;\n\t\t}\n\t}\n\t.datePicker {\n\t\tdisplay: flex;\n\t\tflex-wrap: nowrap;\n\t\t.react-datepicker-popper {\n\t\t\t&[data-placement^='bottom'] {\n\t\t\t\tpadding-top: 5px;\n\t\t\t}\n\t\t\t.react-datepicker {\n\t\t\t\tborder: none;\n\t\t\t\tborder-radius: 2px;\n\t\t\t\tbox-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);\n\t\t\t\tpadding: 10px;\n\t\t\t\t.react-datepicker__triangle {\n\t\t\t\t\t&::before,\n\t\t\t\t\t&::after {\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.react-datepicker__navigation {\n\t\t\t\t\tbox-shadow: none;\n\t\t\t\t\ttop: 7px;\n\t\t\t\t\t// .react-datepicker__navigation--next,\n\t\t\t\t\t// .react-datepicker__navigation--previous {\n\t\t\t\t\t// \ttop: 9px;\n\t\t\t\t\t// }\n\t\t\t\t\t.react-datepicker__navigation-icon::before {\n\t\t\t\t\t\tborder-width: 1px 1px 0 0;\n\t\t\t\t\t\tborder-color: #999;\n\t\t\t\t\t\ttop: 14px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.react-datepicker__month-container {\n\t\t\t\t\t.react-datepicker__header {\n\t\t\t\t\t\tbackground-color: #fff;\n\t\t\t\t\t\tborder-bottom: none;\n\t\t\t\t\t\tpadding: 5px 0;\n\t\t\t\t\t\t.react-datepicker__current-month {\n\t\t\t\t\t\t\tfont-weight: normal;\n\t\t\t\t\t\t\tpadding-bottom: 14px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.react-datepicker__day-names {\n\t\t\t\t\t\t\t.react-datepicker__day-name {\n\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.react-datepicker__month {\n\t\t\t\t\t\t.react-datepicker__week {\n\t\t\t\t\t\t\t.react-datepicker__day {\n\t\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t\t\ttransition: 0.3s;\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tbackground-color: #463dc93d;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.react-datepicker__day--today {\n\t\t\t\t\t\t\t\tcolor: var(--pointColor);\n\t\t\t\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.react-datepicker__day--selected {\n\t\t\t\t\t\t\t\tbackground-color: var(--pointColor);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.react-datepicker__day--keyboard-selected {\n\t\t\t\t\t\t\t\tbackground-color: #a1a1a13d;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\tdiv > .react-datepicker__input-container {\n\t\tposition: relative;\n\t\t.input-datepicker {\n\t\t\theight: 30px;\n\t\t\tborder: none;\n\t\t\tmargin: 0px 2px;\n\t\t\tborder-radius: 2px;\n\t\t\tbox-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);\n\t\t\ttext-indent: 30px;\n\t\t\tfont-size: 0.9rem;\n\t\t}\n\t\t&::before {\n\t\t\tcontent: '';\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\tleft: 10px;\n\t\t\ttop: 50%;\n\t\t\twidth: 16px;\n\t\t\theight: 16px;\n\t\t\ttransform: translateY(-46%);\n\t\t\tbackground: center / contain no-repeat url(../../img/dateIcon.png);\n\t\t}\n\t}\n}\n.container {\n\tposition: relative;\n\t.dropdown-button {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tpadding: 0 40px 0 20px;\n\t\theight: 34px;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tposition: relative;\n\t\t> span {\n\t\t\tfont-size: 0.8rem;\n\t\t}\n\t\t.dropdown-button-arrow {\n\t\t\tposition: absolute;\n\t\t\tright: 20px;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\t}\n\t.dropdown-container {\n\t\t//드롭다운 공통디자인\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\t&.open .dropdown-content {\n\t\t\tdisplay: block;\n\t\t}\n\t\t.dropdown-content {\n\t\t\tposition: absolute; /* 드롭다운을 absolute로 설정 */\n\t\t\tmin-width: 100%;\n\t\t\ttop: 100%; /* 드롭다운을 부모 아래에 표시 */\n\t\t\tleft: 0;\n\t\t\tz-index: 5; /* 다른 요소 위에 나타나도록 설정 */\n\t\t\tdisplay: none; /* 초기에는 숨겨두기 */\n\t\t\tflex-direction: row;\n\t\t\tdisplay: flex;\n\t\t\tword-break: keep-all;\n\t\t\t> li {\n\t\t\t\ttext-align: center;\n\t\t\t\twidth: 100%;\n\t\t\t\tbackground-color: #fff;\n\t\t\t\tpadding: 5px;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\ttransition: 0.1s;\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: #f1f1f1;\n\t\t\t\t\tbackground-color: var(--pointColor);\n\t\t\t\t}\n\t\t\t\t> span {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.modal,\n.overlay {\n\twidth: 100vw;\n\theight: 100vh;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tposition: fixed;\n\tz-index: 10;\n\t.modal-content {\n\t\tposition: relative;\n\t\tz-index: 11;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\tline-height: 1.4;\n\t\tborder-radius: 10px;\n\t\tmax-width: 60%;\n\t\tmin-width: 50%;\n\t\tmin-height: 80%;\n\t\tmax-height: 80%;\n\t\ttext-align: left;\n\t\toverflow: hidden;\n\t\tbackground-color: #f9f9f9;\n\t\t.modal-header {\n\t\t\tposition: fixed;\n\t\t\twidth: 100%;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tpadding: 40px 30px 20px 30px;\n\t\t\tbox-sizing: border-box;\n\t\t\tborder-bottom: 1px solid #b6b6b6;\n\t\t\tbackground: #f1f1f1;\n\t\t\t> h2 {\n\t\t\t\tfont-size: 17px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t}\n\t\t\t> p {\n\t\t\t\tfont-size: 12px;\n\t\t\t\tcolor: #949494;\n\t\t\t}\n\t\t}\n\t\t.modal-body {\n\t\t\tposition: fixed;\n\t\t\ttop: 111px;\n\t\t\tleft: 0;\n\t\t\twidth: 100%;\n\t\t\theight: calc(100% - 111px);\n\t\t\tpadding: 30px;\n\t\t\toverflow-y: scroll;\n\t\t\t/* 아래의 모든 코드는 영역::코드로 사용 */\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\twidth: 10px; /* 스크롤바의 너비 */\n\t\t\t\tbackground-color: #f1f1f1;\n\t\t\t}\n\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\twidth: 5px;\n\t\t\t\theight: 30%; /* 스크롤바의 길이 */\n\t\t\t\tbackground: #b6b6b6; /* 스크롤바의 색상 */\n\t\t\t\tborder-radius: 10px;\n\t\t\t}\n\t\t\t&::-webkit-scrollbar-track {\n\t\t\t\tbackground: #eee; /*스크롤바 뒷 배경 색상*/\n\t\t\t\tborder-radius: 0 10px 10px 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t}\n\t\t\t.modal-row {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t.modal-column {\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-right: 0px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.alignCenter {\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.rowValue {\n\t\t\t\t\t\tflex: 3;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\t> span.value {\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\tmin-width: 160px;\n\t\t\t\t\t\t\tmin-height: 34px;\n\t\t\t\t\t\t\tborder: 1px solid #ddd;\n\t\t\t\t\t\t\tpadding: 5px 10px;\n\t\t\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\t\t\tbox-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n\t\t\t\t\t\t\t> input {\n\t\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t> .addressButton {\n\t\t\t\t\t\theight: 27px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.row-title {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: #949494;\n\t\t\t\ttext-indent: 10px;\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t}\n\t\t\t.modal-column {\n\t\t\t\tflex: 1;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t.modal-column-row {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: row;\n\t\t\t\t\tword-break: keep-all;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t\t> .key {\n\t\t\t\t\t\tmargin-bottom: 0px;\n\t\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tspan.key {\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tcolor: #949494;\n\t\t\t\t\ttext-indent: 10px;\n\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\twidth: 2px;\n\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\tleft: 0px;\n\t\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t\tbackground-color: #ddd;\n\t\t\t\t\t}\n\t\t\t\t\t&.noindent::before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tspan.value {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmin-width: 160px;\n\t\t\t\t\tmin-height: 34px;\n\t\t\t\t\tborder: 1px solid #ddd;\n\t\t\t\t\tpadding: 5px 10px;\n\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\tbox-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n\t\t\t\t\t> input {\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t\t&.values {\n\t\t\t\t\t\tpadding: 0px;\n\t\t\t\t\t\t> span {\n\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t\t\tborder-right: 1px solid #ddd;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tflex: 2;\n\t\t\t\t\t\t\tmin-width: 80px;\n\t\t\t\t\t\t\tpadding: 5px 10px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.resetButton {\n\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\t.resetIconButton {\n\t\t\t\t\t\t\tmargin-right: 0px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.close-modal {\n\t\tposition: fixed;\n\t\ttop: 40px;\n\t\tright: 30px;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tborder: 1px solid #b6b6b6;\n\t\tborder-radius: 12px;\n\t\tdisplay: block;\n\t\tpadding: 5px;\n\t\tcursor: pointer;\n\t\ttransition: 0.2s;\n\t\t&:hover {\n\t\t\tbackground: #b6b6b6;\n\t\t\t&::before,\n\t\t\t&::after {\n\t\t\t\tbackground-color: #eee;\n\t\t\t}\n\t\t}\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\twidth: 80%;\n\t\t\theight: 1px; /* 가로선 두께 설정 */\n\t\t\tbackground: #b6b6b6; /* 가로선 색상 설정 */\n\t\t\ttop: 50%;\n\t\t\tleft: 12%;\n\t\t\ttransform: translateY(-50%);\n\t\t\ttransition: 0.2s;\n\t\t}\n\n\t\t&::before {\n\t\t\ttransform: rotate(45deg);\n\t\t}\n\n\t\t&::after {\n\t\t\ttransform: rotate(-45deg);\n\t\t}\n\t}\n\tbutton {\n\t\tmargin-left: 5px;\n\t\tword-break: keep-all;\n\t\t&.address {\n\t\t\twidth: 200px;\n\t\t}\n\t}\n}\n\n.overlay {\n\tbackground: rgba(49, 49, 49, 0.8);\n}\n.checkboxItem {\n\tpadding: 5px;\n\n\t> label {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tflex-wrap: nowrap;\n\t\tword-break: keep-all;\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t\t&.sale {\n\t\t\tmargin-right: 20px;\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\twidth: 2px;\n\t\t\t\theight: 14px;\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: -15px;\n\t\t\t\ttop: 50%;\n\t\t\t\ttransform: translateY(-44%);\n\t\t\t\tbackground-color: #ccc;\n\t\t\t\tcursor: default;\n\t\t\t}\n\t\t}\n\t\t> input[type='checkbox'] {\n\t\t\tcursor: pointer;\n\t\t\tdisplay: block;\n\t\t\tmargin-right: 5px;\n\t\t\tmargin-bottom: -3px;\n\t\t\taccent-color: var(--pointColor);\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n}\n.radioItem {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tflex-wrap: nowrap;\n\tword-break: keep-all;\n\tcursor: pointer;\n\tposition: relative;\n\t> label {\n\t\tpadding: 5px;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tmargin-bottom: 5px;\n\t\tinput[type='radio'] {\n\t\t\tmargin-right: 5px;\n\t\t\tmargin-bottom: -3px;\n\t\t\tbackground-color: #eee;\n\t\t}\n\t\tinput[type='radio']:checked {\n\t\t\taccent-color: var(--pointColor);\n\t\t}\n\t}\n}\n",".order-table {\n\tposition: relative;\n\twidth: 100%;\n\tz-index: 10;\n\n\t.table-top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 20px 10px 10px 10px;\n\t\t.table-top-left {\n\t\t\tdisplay: flex;\n\t\t\t> p,\n\t\t\tbutton:nth-of-type(1) {\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t}\n\t\t.table-top-right {\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n\ttable {\n\t\ttable-layout: fixed;\n\t\twidth: 100%;\n\t\tbox-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);\n\t\tborder-collapse: collapse;\n\t\tborder-radius: 5px;\n\t\tthead {\n\t\t\tbackground: #efefef;\n\t\t\tth {\n\t\t\t\tfont-weight: 500;\n\t\t\t\tword-break: keep-all;\n\t\t\t\twhite-space: nowrap;\n\t\t\t}\n\t\t}\n\t\ttr {\n\t\t\ttransition: 0.5s;\n\t\t\t&:hover {\n\t\t\t\tbackground-color: #eee;\n\t\t\t}\n\t\t}\n\t\ttd,\n\t\tth {\n\t\t\tword-wrap: break-word;\n\t\t\tpadding: 1em 0.5em;\n\t\t\tvertical-align: middle;\n\t\t\tbox-sizing: border-box;\n\t\t\ttext-align: center;\n\t\t}\n\t\tth:nth-child(6) {\n\t\t\twidth: 200px;\n\t\t\tmin-width: 200px;\n\t\t}\n\t\tth:nth-child(7) {\n\t\t\twidth: 300px;\n\t\t\tmin-width: 300px;\n\t\t}\n\t\ttbody {\n\t\t\tposition: relative;\n\t\t\toverflow: hidden;\n\t\t\t.defaultTable {\n\t\t\t\tbackground: none;\n\t\t\t\ttd {\n\t\t\t\t\t> div {\n\t\t\t\t\t\tpadding: 50px 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.loading {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tborder: 1px solid black;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\tbackground: rgba(49, 49, 49, 0.5);\n\t\t\t\t.loadingImg {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\t@keyframes rotate {\n\t\t\t\t\t\tfrom {\n\t\t\t\t\t\t\ttransform: rotate(0deg);\n\t\t\t\t\t\t}\n\t\t\t\t\t\tto {\n\t\t\t\t\t\t\ttransform: rotate(360deg);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tanimation: rotate 5s infinite;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\ttd {\n\t\t\tborder: 1px solid rgba(0, 0, 0, 0.1);\n\t\t\t.tdInput {\n\t\t\t\tdisplay: flex;\n\t\t\t\t> input {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.deliveryCompanyTrackingNumber {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t}\n}\n.addressCloseButton {\n\tposition: fixed;\n\tleft: 50%;\n\tbottom: 30px;\n\ttransform: translateX(-50%);\n\tz-index: 4;\n}\n.addressOverlay {\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: #eee;\n\tz-index: 2;\n}\n",".searchWord {\n\tdisplay: flex;\n\t> div {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tmargin-right: 20px;\n\t\t> label {\n\t\t\tspan {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t\t&:nth-child(1) {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: flex-start;\n\t\t\t}\n\t\t}\n\t\t&:nth-child(1) {\n\t\t\tlabel {\n\t\t\t\theight: 75px;\n\t\t\t}\n\t\t}\n\t\t&:nth-child(2),\n\t\t&:nth-child(3) {\n\t\t\tlabel:nth-of-type(1) {\n\t\t\t\tmargin-bottom: 5px;\n\t\t\t}\n\t\t}\n\t}\n}\n.categoriesContainer {\n\tdisplay: flex;\n\t> div {\n\t\tmargin-right: 5px;\n\t}\n}\n.hub-table {\n\tposition: relative;\n\twidth: 100%;\n\n\t&::-webkit-scrollbar {\n\t\theight: 10px; /* 스크롤바의 너비 */\n\t\tbackground-color: #f1f1f1;\n\t}\n\t&::-webkit-scrollbar-thumb {\n\t\twidth: 5px;\n\t\theight: 30%; /* 스크롤바의 길이 */\n\t\tbackground: #b6b6b6; /* 스크롤바의 색상 */\n\t\tborder-radius: 10px;\n\t}\n\t&::-webkit-scrollbar-track {\n\t\tbackground: #eee; /*스크롤바 뒷 배경 색상*/\n\t\tborder-radius: 0 10px 10px 0;\n\t\tbox-sizing: border-box;\n\t}\n\t.table-top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 20px 10px 10px 10px;\n\t\t.table-top-left {\n\t\t\tdisplay: flex;\n\t\t}\n\t\t.table-top-right {\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n\t.data-table {\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\theight: auto;\n\t\tmin-height: 110px;\n\t\tdisplay: flex;\n\t\tbox-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);\n\t\tborder-collapse: collapse;\n\t\tborder-radius: 5px;\n\t\t.fixed-table {\n\t\t\tposition: relative;\n\t\t\twidth: 40%;\n\t\t\theight: auto;\n\t\t\toverflow-x: auto;\n\t\t\toverflow-y: hidden;\n\t\t\tz-index: 1;\n\t\t\t> table {\n\t\t\t\twidth: 100%;\n\t\t\t\tbox-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);\n\t\t\t\tborder-collapse: collapse;\n\t\t\t\tborder-radius: 5px 0 0 5px;\n\t\t\t\tthead {\n\t\t\t\t\tbackground: #efefef;\n\t\t\t\t\tth {\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\ttd {\n\t\t\t\t\tborder-right: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.scroll-table {\n\t\t\tposition: relative;\n\t\t\twidth: 60%;\n\t\t\theight: auto;\n\t\t\t// max-width: 60%;\n\t\t\toverflow-x: auto;\n\t\t\toverflow-y: hidden;\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\twidth: 10px; /* 스크롤바의 너비 */\n\t\t\t\theight: 10px;\n\t\t\t\tbackground-color: #f1f1f1;\n\t\t\t}\n\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\twidth: 5px;\n\t\t\t\theight: 30%; /* 스크롤바의 길이 */\n\t\t\t\tbackground: #b6b6b6; /* 스크롤바의 색상 */\n\t\t\t\tborder-radius: 10px;\n\t\t\t}\n\t\t\t&::-webkit-scrollbar-track {\n\t\t\t\tbackground: #eee; /*스크롤바 뒷 배경 색상*/\n\t\t\t\tborder-radius: 0 10px 10px 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t}\n\t\t}\n\t\ttable {\n\t\t\tborder-collapse: collapse;\n\t\t\tposition: absolute;\n\t\t\tbackground: #fff;\n\t\t\tmin-height: 200px;\n\t\t\toverflow: hidden;\n\t\t\tbox-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);\n\t\t\tborder-collapse: collapse;\n\t\t\tborder-radius: 0 5px 5px 0;\n\t\t\tthead {\n\t\t\t\tbackground: #efefef;\n\t\t\t\ttr {\n\t\t\t\t\tth {\n\t\t\t\t\t\twidth: 200px;\n\t\t\t\t\t\theight: 50px;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tword-break: keep-all;\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\ttbody {\n\t\t\t\tposition: relative;\n\t\t\t\ttr {\n\t\t\t\t\ttransition: 0.5s;\n\t\t\t\t\t// &:hover {\n\t\t\t\t\t// \tbackground-color: #eee;\n\t\t\t\t\t// }\n\t\t\t\t\ttd {\n\t\t\t\t\t\twidth: 200px;\n\t\t\t\t\t\theight: 50px;\n\t\t\t\t\t\tword-break: keep-all;\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\tvertical-align: middle;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\tpadding: 10px 5px;\n\t\t\t\t\t\tborder: 1px solid rgba(0, 0, 0, 0.1);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.defaultTable {\n\t\t\t\t\tbackground: none;\n\t\t\t\t\ttd {\n\t\t\t\t\t\ttext-align: left;\n\t\t\t\t\t\tpadding-left: 10%;\n\t\t\t\t\t\t> div {\n\t\t\t\t\t\t\tpadding: 50px 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.slide-modal,\n.slide-overlay {\n\twidth: 100%;\n\theight: 100vh;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\toverflow: visible;\n\t.slide-overlay {\n\t\tbackground: rgba(49, 49, 49, 0.8);\n\t}\n\n\t.slide-modal-content {\n\t\tposition: relative;\n\t\toverflow-x: auto;\n\t\ttop: 0;\n\t\tleft: 10%;\n\t\tborder-radius: 10px 0 0 10px;\n\t\twidth: 90%;\n\t\theight: 100vh;\n\t\ttext-align: left;\n\t\tz-index: 100;\n\n\t\t.modal-header {\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\ttop: 0;\n\t\t\twidth: 100%;\n\t\t\tpadding: 40px 30px 20px 30px;\n\t\t\tborder-bottom: 1px solid #b6b6b6;\n\t\t\tbackground: #f1f1f1;\n\t\t\tz-index: 2;\n\t\t\t> h2 {\n\t\t\t\tfont-size: 17px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t}\n\t\t\t> p {\n\t\t\t\tfont-size: 12px;\n\t\t\t\tcolor: #949494;\n\t\t\t}\n\t\t}\n\t\t.close-modal {\n\t\t\tposition: absolute;\n\t\t\ttop: 40px;\n\t\t\tright: 30px;\n\t\t\twidth: 24px;\n\t\t\theight: 24px;\n\t\t\tborder: 1px solid #b6b6b6;\n\t\t\tborder-radius: 12px;\n\t\t\tdisplay: block;\n\t\t\tpadding: 5px;\n\t\t\tcursor: pointer;\n\t\t\ttransition: 0.2s;\n\t\t\tz-index: 3;\n\t\t\t&:hover {\n\t\t\t\tbackground: #b6b6b6;\n\t\t\t\t&::before,\n\t\t\t\t&::after {\n\t\t\t\t\tbackground-color: #eee;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&::before,\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 80%;\n\t\t\t\theight: 1px; /* 가로선 두께 설정 */\n\t\t\t\tbackground: #b6b6b6; /* 가로선 색상 설정 */\n\t\t\t\ttop: 50%;\n\t\t\t\tleft: 12%;\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\ttransition: 0.2s;\n\t\t\t}\n\n\t\t\t&::before {\n\t\t\t\ttransform: rotate(45deg);\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\ttransform: rotate(-45deg);\n\t\t\t}\n\t\t}\n\t\tbutton {\n\t\t\tword-break: keep-all;\n\t\t}\n\t\t.modal-body {\n\t\t\tposition: relative;\n\t\t\twidth: 100%;\n\t\t\ttop: 112px;\n\t\t\theight: calc(100vh - 112px);\n\t\t\tpadding: 30px;\n\t\t\toverflow: auto;\n\t\t\tz-index: 1;\n\t\t\tbackground-color: #f9f9f9;\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\twidth: 10px; /* 스크롤바의 너비 */\n\t\t\t\theight: 10px;\n\t\t\t\tbackground-color: #f1f1f1;\n\t\t\t}\n\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\twidth: 5px;\n\t\t\t\theight: 30%; /* 스크롤바의 길이 */\n\t\t\t\tbackground: #b6b6b6; /* 스크롤바의 색상 */\n\t\t\t\tborder-radius: 10px;\n\t\t\t}\n\t\t\t&::-webkit-scrollbar-track {\n\t\t\t\tbackground: #eee; /*스크롤바 뒷 배경 색상*/\n\t\t\t\tborder-radius: 0 10px 10px 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t}\n\n\t\t\t.detailModalInfo {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\talign-items: stretch;\n\t\t\t\tbackground-color: #f9f9f9;\n\t\t\t\tmargin-bottom: 40px;\n\t\t\t\t.imgInfo {\n\t\t\t\t\twidth: 38%;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: row;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\talign-items: flex-start;\n\t\t\t\t\tpadding: 5px;\n\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\t.imgList {\n\t\t\t\t\t\twidth: 20%;\n\t\t\t\t\t\tmin-width: 76px;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\twidth: 76px;\n\t\t\t\t\t\t\theight: 76px;\n\t\t\t\t\t\t\tpadding: 5px;\n\t\t\t\t\t\t\tborder: 1px solid #b6b6b6;\n\t\t\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\t\t\t> img {\n\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\t\tobject-fit: cover;\n\t\t\t\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t> .img {\n\t\t\t\t\t\twidth: 80%;\n\t\t\t\t\t\tmax-height: 600px;\n\t\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t\t\tpadding: 6px;\n\t\t\t\t\t\tborder: 1px solid #b6b6b6;\n\t\t\t\t\t\t> img {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\tobject-fit: contain;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t> .info {\n\t\t\t\t\twidth: 60%;\n\t\t\t\t\tpadding: 20px;\n\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\tposition: relative;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.detail-content {\n\t\t\t\tmargin-bottom: 40px;\n\t\t\t\tposition: relative;\n\t\t\t\twidth: 100%;\n\t\t\t\t.detail-content-top {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t.detail-content-title {\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\ttext-indent: 10px;\n\t\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\twidth: 2px;\n\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\t\tleft: 0px;\n\t\t\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t\t\tbackground-color: #ddd;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.buttonBox {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\theight: 34px;\n\t\t\t\t\t\t> .reset {\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t> span {\n\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t\tfont-size: 0.8rem;\n\t\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\t\t> img {\n\t\t\t\t\t\t\t\t\tmargin-top: 4px;\n\t\t\t\t\t\t\t\t\theight: 18px;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t> button {\n\t\t\t\t\t\t\tmargin-right: 5px;\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tmargin-right: 0px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.detail-content-html {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t> textarea {\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\tmin-height: 400px;\n\t\t\t\t\t\tbackground-color: #ffff;\n\t\t\t\t\t\tbox-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);\n\t\t\t\t\t\tborder-collapse: collapse;\n\t\t\t\t\t\tborder-radius: 5px;\n\t\t\t\t\t\twhite-space: normal;\n\t\t\t\t\t\tpadding: 10px;\n\t\t\t\t\t\tresize: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t> img {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\t\t.modal,\n\t\t\t\t.overlay {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100vh;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tposition: fixed;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\t.imagePreviewPopup-content {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: 50%;\n\t\t\t\t\t\ttop: 140px;\n\t\t\t\t\t\tz-index: 101;\n\t\t\t\t\t\ttransform: translateX(-42%);\n\t\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\t\tmax-width: 80%;\n\t\t\t\t\t\tmin-width: 60%;\n\t\t\t\t\t\tmin-height: 80%;\n\t\t\t\t\t\tmax-height: 80%;\n\t\t\t\t\t\tbackground-color: #f9f9f9;\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t.modal-header {\n\t\t\t\t\t\t\tposition: fixed;\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\tpadding: 30px 20px;\n\t\t\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\t\t\tborder-bottom: 1px solid #b6b6b6;\n\t\t\t\t\t\t\tbackground: #f1f1f1;\n\t\t\t\t\t\t\t.imagePreview-header-text {\n\t\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\tcolor: #949494;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.modal-body {\n\t\t\t\t\t\t\tposition: fixed;\n\t\t\t\t\t\t\ttop: 95px;\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\theight: calc(100% - 95px);\n\t\t\t\t\t\t\tpadding: 30px;\n\t\t\t\t\t\t\toverflow-y: scroll;\n\t\t\t\t\t\t\t/* 아래의 모든 코드는 영역::코드로 사용 */\n\t\t\t\t\t\t\t&::-webkit-scrollbar {\n\t\t\t\t\t\t\t\twidth: 10px; /* 스크롤바의 너비 */\n\t\t\t\t\t\t\t\tbackground-color: #f1f1f1;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\t\t\t\t\twidth: 5px;\n\t\t\t\t\t\t\t\theight: 30%; /* 스크롤바의 길이 */\n\t\t\t\t\t\t\t\tbackground: #b6b6b6; /* 스크롤바의 색상 */\n\t\t\t\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&::-webkit-scrollbar-track {\n\t\t\t\t\t\t\t\tbackground: #eee; /*스크롤바 뒷 배경 색상*/\n\t\t\t\t\t\t\t\tborder-radius: 0 10px 10px 0;\n\t\t\t\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.close-modal {\n\t\t\t\t\t\tposition: fixed;\n\t\t\t\t\t\ttop: 30px;\n\t\t\t\t\t\tright: 30px;\n\t\t\t\t\t\twidth: 24px;\n\t\t\t\t\t\theight: 24px;\n\t\t\t\t\t\tborder: 1px solid #b6b6b6;\n\t\t\t\t\t\tborder-radius: 12px;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tpadding: 5px;\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\ttransition: 0.2s;\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground: #b6b6b6;\n\t\t\t\t\t\t\t&::before,\n\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\tbackground-color: #eee;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&::before,\n\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\twidth: 80%;\n\t\t\t\t\t\t\theight: 1px; /* 가로선 두께 설정 */\n\t\t\t\t\t\t\tbackground: #b6b6b6; /* 가로선 색상 설정 */\n\t\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\t\tleft: 12%;\n\t\t\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t\t\ttransition: 0.2s;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\ttransform: rotate(-45deg);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.modal-row {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t.modal-column {\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-right: 0px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.row-title {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: #949494;\n\t\t\t\ttext-indent: 10px;\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t}\n\t\t\t.modal-column {\n\t\t\t\tflex: 1;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t.modal-column-row {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: row;\n\t\t\t\t\tword-break: keep-all;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t\t> .key {\n\t\t\t\t\t\tmargin-bottom: 0px;\n\t\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tspan.key {\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tcolor: #949494;\n\t\t\t\t\ttext-indent: 10px;\n\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\twidth: 2px;\n\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\tleft: 0px;\n\t\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t\tbackground-color: #ddd;\n\t\t\t\t\t}\n\t\t\t\t\t&.noindent::before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tspan.value {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmin-width: 160px;\n\t\t\t\t\tmin-height: 34px;\n\t\t\t\t\tborder: 1px solid #ddd;\n\t\t\t\t\tpadding: 5px 10px;\n\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\tbox-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n\t\t\t\t\t> input {\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t\t&.values {\n\t\t\t\t\t\tpadding: 0px;\n\t\t\t\t\t\t> span {\n\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t\t\tborder-right: 1px solid #ddd;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tflex: 2;\n\t\t\t\t\t\t\tmin-width: 80px;\n\t\t\t\t\t\t\tpadding: 5px 10px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t> .reset {\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t> span {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tfont-size: 0.8rem;\n\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\t> img {\n\t\t\t\t\t\t\t\tmargin-top: 4px;\n\t\t\t\t\t\t\t\theight: 18px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.modResetButton {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: 20px;\n\t\t\t\t\ttop: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.loading {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-color: rgba(49, 49, 49, 0.5);\n\ttransition: 0.3s;\n\t> td {\n\t\tborder: none !important;\n\t}\n\t&.hub {\n\t\t.loadingImg {\n\t\t\tmargin-left: -100%;\n\t\t}\n\t}\n\t&.noBg {\n\t\ttransition: 0.3s;\n\t\tbackground-color: rgba(49, 49, 49, 0);\n\t}\n\t.loadingImg {\n\t\tdisplay: block;\n\t\t@keyframes rotate {\n\t\t\tfrom {\n\t\t\t\ttransform: rotate(0deg);\n\t\t\t}\n\t\t\tto {\n\t\t\t\ttransform: rotate(360deg);\n\t\t\t}\n\t\t}\n\t\tanimation: rotate 5s infinite;\n\t}\n}\n",".market-layout {\n\tpadding: 40px;\n\tdisplay: flex;\n\tgap: 6%;\n}\n.market-top {\n\twidth: 30%;\n\tpadding-top: 100px;\n\t.button {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 100px;\n\t\t.registration {\n\t\t\twidth: 70%;\n\t\t\th2 {\n\t\t\t\tfont-size: 1.4rem;\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t}\n\t\t\t.checkbox {\n\t\t\t\tcolor: var(--pointColor);\n\t\t\t\tborder-radius: 3px;\n\t\t\t\t// border: 1px solid var(--pointColor);\n\t\t\t\t// background-color: rgba(70, 61, 201, 0.086);\n\t\t\t\tposition: relative;\n\t\t\t\tpadding-left: 20px; /* 체크박스 왼쪽 여백 조절 */\n\t\t\t\tfont-size: 0.7rem;\n\t\t\t\t&::before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 2px;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\ttransform: translateY(-48%);\n\t\t\t\t\twidth: 10px; /* 체크표시의 가로 길이 조절 */\n\t\t\t\t\theight: 10px; /* 체크표시의 세로 길이 조절 */\n\t\t\t\t\tborder: 1px solid var(--pointColor); /* 체크표시의 테두리 스타일과 색상 설정 */\n\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\tbackground-color: transparent; /* 체크표시의 배경 색상 설정 */\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t\t&.checked::before {\n\t\t\t\t\tcontent: '\\2713'; /* 유니코드로 체크마크 추가 */\n\t\t\t\t\tfont-size: 8px; /* 체크마크의 크기 조절 */\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tcolor: var(--pointColor); /* 체크마크의 색상 설정 */\n\t\t\t\t\tline-height: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t> button {\n\t\t\tbackground-color: #222;\n\t\t\tcolor: #eee;\n\t\t\tpadding: 9px 20px;\n\t\t\twidth: 30%;\n\t\t\theight: 40px;\n\t\t}\n\t}\n\n\t.selectedData {\n\t\twidth: 100%;\n\t}\n}\n.market-table {\n\tposition: relative;\n\twidth: 70%;\n\tz-index: 10;\n\t.table-top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 20px 10px 10px 10px;\n\t\t.table-top-left {\n\t\t\tdisplay: flex;\n\t\t\t> p,\n\t\t\tbutton:nth-of-type(1) {\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t}\n\t\t.table-top-right {\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n\ttable {\n\t\ttable-layout: fixed;\n\t\twidth: 100%;\n\t\tbox-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.2);\n\t\tborder-collapse: collapse;\n\t\tborder-radius: 5px;\n\t\tthead {\n\t\t\tth {\n\t\t\t\tfont-weight: 500;\n\t\t\t\tword-break: keep-all;\n\t\t\t\twhite-space: nowrap;\n\t\t\t}\n\t\t}\n\t\ttr {\n\t\t\ttransition: 0.5s;\n\t\t\t&:hover {\n\t\t\t\tbackground-color: #eee;\n\t\t\t}\n\t\t}\n\t\ttd,\n\t\tth {\n\t\t\tword-wrap: break-word;\n\t\t\tpadding: 1em 0.5em;\n\t\t\tvertical-align: middle;\n\t\t\tbox-sizing: border-box;\n\t\t\ttext-align: center;\n\t\t}\n\t\tth:nth-child(3) {\n\t\t\tmin-width: 160px;\n\t\t}\n\t\tth:nth-child(1) {\n\t\t\tmin-width: 120px;\n\t\t}\n\t\ttbody {\n\t\t\tposition: relative;\n\t\t\toverflow: hidden;\n\t\t\t.defaultTable {\n\t\t\t\tbackground: none;\n\t\t\t\ttd {\n\t\t\t\t\t> div {\n\t\t\t\t\t\tpadding: 50px 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.loading {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tborder: 1px solid black;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\tbackground: rgba(49, 49, 49, 0.5);\n\t\t\t\t.loadingImg {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\t@keyframes rotate {\n\t\t\t\t\t\tfrom {\n\t\t\t\t\t\t\ttransform: rotate(0deg);\n\t\t\t\t\t\t}\n\t\t\t\t\t\tto {\n\t\t\t\t\t\t\ttransform: rotate(360deg);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tanimation: rotate 5s infinite;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\ttd {\n\t\t\tborder: 1px solid rgba(0, 0, 0, 0.1);\n\t\t\t.tdInput {\n\t\t\t\tdisplay: flex;\n\t\t\t\t> input {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.marketRegistrationModal {\n\tposition: fixed;\n\tright: 0;\n\ttop: 0;\n\twidth: 65%;\n\theight: 100vh;\n\tdisplay: flex;\n\tjustify-content: center;\n\ttransition: 0.3s;\n\tbackground-color: #f3f3f3;\n\tz-index: 10;\n\n\t.slide-modal-content {\n\t\tposition: absolute;\n\t\toverflow-y: scroll;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tpadding: 60px 10% 20px;\n\t\t&::-webkit-scrollbar {\n\t\t\twidth: 10px; /* 스크롤바의 너비 */\n\t\t\tbackground-color: #f1f1f1;\n\t\t}\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\twidth: 10px;\n\t\t\tbackground: #b6b6b6; /* 스크롤바의 색상 */\n\t\t\tborder-radius: 10px;\n\t\t}\n\t\t&::-webkit-scrollbar-track {\n\t\t\tbackground: #f3f3f3; /*스크롤바 뒷 배경 색상*/\n\t\t}\n\t\t.counters {\n\t\t\twidth: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tpadding-bottom: 40px;\n\t\t\tborder-bottom: 0.5px solid #fff;\n\t\t\tspan {\n\t\t\t\tdisplay: block;\n\t\t\t\twidth: 40px;\n\t\t\t\theight: 40px;\n\t\t\t\tborder-radius: 25px;\n\t\t\t\tbackground-color: #333;\n\t\t\t\tcolor: #fff;\n\t\t\t\ttext-align: center;\n\t\t\t\tline-height: 40px;\n\t\t\t\ttransition: 0.3s;\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tfont-weight: 300;\n\t\t\t\t&.on {\n\t\t\t\t\tbackground-color: var(--pointColor);\n\t\t\t\t\tcolor: #efefef;\n\t\t\t\t}\n\t\t\t}\n\t\t\tem {\n\t\t\t\twidth: 100px;\n\t\t\t\theight: 2px;\n\t\t\t\tbackground-color: #333;\n\t\t\t\ttransition: 0.3s;\n\t\t\t\t&.on {\n\t\t\t\t\tbackground-color: var(--pointColor);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.slides {\n\t\t\twidth: 100%;\n\t\t\t.radioItem {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tflex-wrap: wrap;\n\t\t\t\tmargin-bottom: 40px;\n\t\t\t\tlabel {\n\t\t\t\t\twidth: 30%;\n\t\t\t\t\tborder: 1px solid #ccc;\n\t\t\t\t\tpadding: 26px 0px;\n\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\ttransition: 0.3s;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t&.on {\n\t\t\t\t\t\tborder: 2px solid var(--pointColor);\n\t\t\t\t\t\tbackground-color: #f8f8f8;\n\t\t\t\t\t}\n\t\t\t\t\tinput {\n\t\t\t\t\t\t-moz-appearance: none;\n\t\t\t\t\t\t-webkit-appearance: none;\n\t\t\t\t\t\tappearance: none;\n\t\t\t\t\t\tbackground-color: transparent;\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t\t> span {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t> input {\n\t\t\t\twidth: 100%;\n\t\t\t\ttext-indent: 5px;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\t\t}\n\t\t.buttons {\n\t\t\twidth: 100%;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-end;\n\t\t\tgap: 10%;\n\t\t\t> button {\n\t\t\t\twidth: 45%;\n\t\t\t\tpadding: 10px 0;\n\t\t\t\t&.rightBtn,\n\t\t\t\t&.taskRegistrationBtn,\n\t\t\t\t&.registrationBtn {\n\t\t\t\t\tbackground-color: var(--pointColor);\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t}\n\t\t\t\t&.rightBtn:disabled,\n\t\t\t\t&.taskRegistrationBtn:disabled {\n\t\t\t\t\tbackground-color: #f8f8f8;\n\t\t\t\t\tcolor: #999;\n\t\t\t\t\tcursor: auto;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.tabs {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\tgap: 2px;\n\t\t\tmargin-bottom: 20px;\n\t\t\tli {\n\t\t\t\tborder: 1px solid rgba(0, 0, 0, 0.3);\n\t\t\t\tbackground-color: #f9f9f9;\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 10px 14px;\n\t\t\t\tfont-size: 0.8rem;\n\t\t\t\ttransition: 0.3s;\n\t\t\t\t&.active {\n\t\t\t\t\tbackground-color: #222;\n\t\t\t\t\tcolor: #eee;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.tables {\n\t\t\tpadding-bottom: 30px;\n\t\t\t.tamplate-table {\n\t\t\t\tposition: relative;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: auto;\n\t\t\t\t> table {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tbox-shadow: 0 0 1px 0px rgba(0, 0, 0, 0.2);\n\t\t\t\t\tborder-collapse: collapse;\n\t\t\t\t\tborder-radius: 5px 0 0 5px;\n\t\t\t\t\tbackground-color: #f9f9f9;\n\t\t\t\t\tth {\n\t\t\t\t\t\tbackground: #efefef;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tborder: 1px solid rgba(0, 0, 0, 0.1);\n\t\t\t\t\t}\n\t\t\t\t\ttd {\n\t\t\t\t\t\tborder: 1px solid rgba(0, 0, 0, 0.1);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.updateButton {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-end;\n\t\t\tmargin-bottom: 30px;\n\t\t\t> button {\n\t\t\t\tdisplay: block;\n\t\t\t\twidth: 140px;\n\t\t\t\theight: 45px;\n\t\t\t\t// background-color: var(--pointColor);\n\t\t\t\t// color: #fff;\n\t\t\t}\n\t\t}\n\t}\n}\n\nh3 {\n\tfont-size: 1rem;\n\tfont-weight: 400;\n\tmargin: 20px 0;\n\tposition: relative;\n\t// &::before {\n\t// \tcontent: '';\n\t// \tdisplay: block;\n\t// \twidth: 2px;\n\t// \theight: 100%;\n\t// \tposition: absolute;\n\t// \ttop: 50%;\n\t// \tleft: 0px;\n\t// \ttransform: translateY(-50%);\n\t// \tbackground-color: #ddd;\n\t// }\n\t> span {\n\t\tpadding-right: 20px;\n\t\tsvg {\n\t\t\tcolor: #bbb;\n\t\t\tmargin-left: 5px;\n\t\t\tmargin-bottom: -2px;\n\t\t\ttransition: 0.3s;\n\t\t}\n\t\t&.on {\n\t\t\tsvg {\n\t\t\t\tcolor: var(--pointColor);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.modal-content {\n\t> h3 {\n\t\tmargin-bottom: 40px;\n\t\ttext-align: center;\n\t}\n\t.modal-body {\n\t\twidth: 100%;\n\t\tmargin-bottom: 20px;\n\t\t.modal-row {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tjustify-content: space-between;\n\t\t\tmargin-bottom: 10px;\n\t\t\t.modal-column {\n\t\t\t\tmargin-right: 10px;\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-right: 0px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.modal-column {\n\t\t\tflex: 1;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: flex-start;\n\t\t\tmargin-bottom: 10px;\n\t\t\t.modal-column-row {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\tword-break: keep-all;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t> .key {\n\t\t\t\t\tmargin-bottom: 0px;\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t\tspan.key {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: #949494;\n\t\t\t\ttext-indent: 10px;\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t\tposition: relative;\n\t\t\t\t&::before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\twidth: 2px;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 0px;\n\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\tbackground-color: #ddd;\n\t\t\t\t}\n\t\t\t}\n\t\t\tspan.value {\n\t\t\t\tdisplay: flex;\n\t\t\t\twidth: 100%;\n\t\t\t\tmin-width: 160px;\n\t\t\t\tmin-height: 34px;\n\t\t\t\tborder: 1px solid #ddd;\n\t\t\t\tpadding: 5px 10px;\n\t\t\t\tborder-radius: 10px;\n\t\t\t\tbox-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n\t\t\t\tbackground-color: #f9f9f9;\n\t\t\t}\n\t\t}\n\t}\n}\n",".proc {\n\tdisplay: flex;\n\tmargin: 80px 7vw 60px;\n\t> h2 {\n\t\tflex: 1;\n\t\tfont-size: 3rem;\n\t}\n\t.procBox {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\t> h3 {\n\t\t\tcolor: #333;\n\t\t\tfont-size: 1.4rem;\n\t\t\tmargin-bottom: 30px;\n\t\t}\n\t\t> button {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: flex-start;\n\t\t\talign-items: start;\n\t\t\twidth: 90%;\n\t\t\theight: 100px;\n\t\t\ttext-align: left;\n\t\t\tborder: none;\n\t\t\tbox-shadow: none;\n\t\t\tbackground-color: transparent;\n\t\t\tfont-size: 1rem;\n\t\t\tpadding: 10px 20px 10px 10px;\n\t\t\t.button-title {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tmargin-bottom: 12px;\n\t\t\t\tcolor: var(--pointColor);\n\t\t\t\t.button-title-left {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 10px;\n\t\t\t\t\t> svg {\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t.special-rotate {\n\t\t\t\t\t\t\ttransform-origin: 142px 47px;\n\t\t\t\t\t\t\ttransform: scale(90%);\n\t\t\t\t\t\t\ttransition: transform 0.5s ease;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t> span {\n\t\t\t\t\ttransition: 0.3s;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\tborder: solid black;\n\t\t\t\t\t\tborder-width: 0.1em 0.1em 0 0;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tpadding: 3px;\n\t\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t> p {\n\t\t\t\tcolor: #666;\n\t\t\t\tfont-size: 0.8rem;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tbackground-color: #f3f3f3;\n\t\t\t\t.button-title {\n\t\t\t\t\ttransition: 0.3s;\n\t\t\t\t\t.button-title-left {\n\t\t\t\t\t\tsvg {\n\t\t\t\t\t\t\t.special-rotate {\n\t\t\t\t\t\t\t\ttransition: transform 0.2s ease;\n\t\t\t\t\t\t\t\ttransform-origin: 142px 47px;\n\t\t\t\t\t\t\t\ttransform: rotate(45deg) scale(90%);\n\t\t\t\t\t\t\t\tfill: var(--pointColor);\n\t\t\t\t\t\t\t\tstroke: var(--pointColor);\n\t\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t> span {\n\t\t\t\t\t\ttransform: translateX(5px);\n\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\tborder: solid var(--pointColor);\n\t\t\t\t\t\t\tborder-width: 0.1em 0.1em 0 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
